export const lang = {
  common: {
    play: 'Play',
    viewMore: 'View More',
    currency: 'Currency',
    fail: 'Fail',
    success: 'Success',
    downLoad: 'Download',
    next: 'Next',
    finish: 'Finish',
    cancel: 'Cancel',
    login: 'Log In',
    ok: 'OK',
    errorPrompt: 'An error has occurred. Please try again or contact our support.',
    submit: 'Submit',
    joinin: 'Join Now',
    search: 'Search'
  },
  betActivity: {
    todayBet: 'Today’s Betting Amount',
    estimatedReward: 'Estimated Reward',
    distributingTomorrow: '(Distributing tomorrow)',
    yesterdayReward: 'Yesterday’s Reward',
    cashReward: 'Cash Reward',
    rules: 'Rules',
    history: 'History',
    date: 'Date',
    bettingAmount: 'Betting Amount',
    reward: 'Reward',
    noDataAvailable: 'No Data Available',
    activityNotStartYetMessageContent: 'Activity not start yet',
    activityNotStartYetMessageTitle: 'Sorry',
    confirmButtonText: 'OK'
  },
  betActivityWeekly: {
    BetThisWeek: 'Betting this Week',
    estimatedReward: 'Estimated Reward',
    distributingNextWeek: '(Distributing Next Week)',
    RewardOfLastWeek: 'Reward of Last Week',
    cashReward: 'Summary',
    rules: 'Rules',
    history: 'History',
    week: 'Week',
    bettingAmount: 'Betting Amount',
    reward: 'Reward',
    noDataAvailable: 'No Data Available',
    joinNow: 'JOIN NOW',
    play: 'PLAY',
    activityNotStartYetMessageContent: 'Activity not start yet',
    activityNotStartYetMessageTitle: 'Sorry',
    confirmButtonText: 'OK'
  },
  betActivityRegularly: {
    cashbackRewards: 'Rebate',
    slogan: 'Place bets to earn cashback rewards. The more you bet, the more you earn',
    rewardsAvailable: 'Rewards Available',
    totalReceived: 'Total Received',
    claimNow: 'Claim Now',
    playNow: 'Play Now',
    rules: 'Rules',
    details: 'Details',
    totalRewards: 'Total Rewards',
    totalBet: 'Total Bet',
    games: 'Games',
    bet: 'Bet',
    rewards: 'Rewards',
    records: 'Records',
    Success: 'Success',
    claimResultSuccess: 'Reward has been claimed. Bet now to get more!',
    claimResultFailed: 'No rewards available. Bet now to get more!',
    claimResultNotReached: '*The rebate will be issued after 12:00 every day.',
    cancel: 'Cancel',
    noDataAvailable: 'No Data Available',
    receive: 'Receive'
  },
  WelfareDeposit: {
    title1: 'Limited Time Deposit Bonus',
    title2: 'Up to ',
    title3: ' Extra Free Money',
    discount1: 'You still have a discount available to use. ',
    discount2: 'Don’t waste it before it expires.',
    deposit: 'Deposit',
    cancel: 'Cancel'
  },
  RewardTypes: {
    Name1: 'Invite Reward',
    Description1: 'Sign-up & 3x plays',
    Name2: 'Deposit Reward',
    Description2: '5% of Deposited amount',
    Name3: 'Deposit Reward',
    Description3: '10K deposit',
    Name5: 'Invite Reward',
    Description5: 'Friend Sign up & Deposit',
    Name6: 'Deposit Reward',
    Description6: 'Friend Deposit',
    Name7: 'Betting Reward',
    Description7: 'Friend Betting more than 500',
    Name8: 'Agent Reward',
    Description8: 'Deposit',
    Name9: 'Agent Reward',
    Description9: 'Betting'
  },
  gameCatetory: {
    LiveCasino: 'LiveCasino',
    SlotGames: 'SlotGames',
    Lottery: 'Lottery',
    FishingGames: 'FishingGames',
    SportsGames: 'SportsGames',
    DOWN: 'DOWN',
    Card: 'Card',
    MostPopular: 'MostPopular'
  },
  menu: {
    Home: 'Home',
    Games: 'Games',
    Promotion: 'Promotion',
    FAQ: 'FAQ',
    Deposit: 'Deposit',
    Withdraw: 'Withdraw',
    Account: 'Account',
    Edit: 'Edit Info',
    History: 'History',
    Message: 'Message',
    Support: 'Support',
    Terms: 'Terms and Conditions',
    Privacy: 'Privacy Policy',
    Responsible: 'Responsible Gambling',
    Affiliate: 'Affiliate',
    Login: 'Log In',
    Logout: 'Log Out',
    AboutUs: 'About Us',
    News: 'News',
    Kyc: 'KYC Policy',
    BackToHome: 'Back Home',
    Language: 'Language',
    VIP: 'Vip'
  },
  footer: {
    Home: 'Home',
    Events: 'Events',
    Promotion: 'Promotion',
    Deposit: 'Deposit',
    Withdraw: 'Withdraw',
    Support: 'Support',
    Agent: 'Agent',
    Affiliate: 'Affiliate'
  },
  rule: {
    Deposit: 'DEPOSIT',
    Play: 'PLAY',
    OK: 'OK',
    CollectNow: 'Collect Now',
    Invite: 'Invite',
    Go: 'GO'
  },
  label: {
    POPULAR: 'MOST POPULAR',
    CASINO: 'LIVE CASINO',
    LOTTERY: 'LOTTERY',
    CARD: 'CARD',
    FISHING: 'FISHING GAMES',
    SLOTS: 'SLOTS',
    hot: 'Hot',
    live: 'Live Dealers',
    lottery: 'Lottery',
    card: 'Card',
    crash: 'Crash',
    fishing: 'Fishing',
    slots: 'Slots',
    sports: 'Sports',
    casino: 'Live Casino'
  },
  affiliate: {
    rank: 'Rank',
    rules: 'Rules',
    share: 'Share',
    welcomeMessage: 'Join me in PGEBet to play games and win big! %0A %0A 1. Click the link to download the PGEBet App: {downloadURL} %0A 2. Use code {shareCode} to signup. %0A 3. Get ₹177 %2B ₹20 Exclusive Free Cash %26 Up To ₹2500 First Deposit Bonus. %0A %0A Rummy, Teen Patti, Aviator, Live Casino, Cricket, Slots are waiting for you to play!',
    confirmButtonText: 'OK',
    activityNotStartYetMessageTitle: 'Notice',
    activityNotStartYetMessageContent: 'The promotion will start soon.',
    activityEndedMessageTitle: 'Notice',
    activityEndedMessageContent: 'The promotion has ended and the prize will be issued within 48 hours.'
  },
  promotion: {
    All: 'All',
    Expired: 'Expired',
    GamePromotion: 'GamePromotion',
    Jili: 'Jili',
    Daily: 'Daily',
    FreeCash: 'Free Cash',
    Deposit: 'Deposit',
    Betting: 'Betting',
    Affiliate: 'Affiliate',
    rules: 'Rules',
    title1: '100% DEPOSIT BONUS',
    desc1_1: 'Receive 100% Bonus on your Deposit!',
    desc1_2: '<div style="text-align: center; display: block; width: 100%">Wagering 40X',
    desc1_3: '<div style="text-align: center; display: block; width: 100%">One time use only | No Deposit Limits',
    title2: '#CurrentMonthUpper# MADNESS',
    desc2_1: '₹2.5m each for Top 3 Biggest Daily Winners in #CurrentMonthNormal#',
    desc2_2: 'Paid out instantly on #LastDateOfCurrentMonth#',
    title3: 'Diwali 10-day Bonus',
    desc3_1: 'Happy Diwali 2021',
    desc3_2: '150% Bonus for every deposit you make from 4 Nov to 17 Nov',
    title4: 'Invite and Earn ₹',
    desc4_1: '①<div style="margin-left: 10px;flex: 1;text-align: left;">Get an instant ₹10 for inviting each friend to sign up and play.',
    desc4_2: '②<div style="margin-left: 10px;flex: 1;text-align: left;">Get 5% of every deposit your friend makes and another ₹500 if his/her total deposit is over ₹10,000.',
    desc4_3: '③<div style="margin-left: 10px;flex: 1;text-align: left;">Total rewards up to ₹100 Million!',
    title5: '10 Big Winners Month',
    desc5_1: 'During the promotion period, the top 10 players who win most will be able to share over 10m rupees in cash rewards!',
    title6: 'Stay Online and Win Cash',
    desc6_1: 'Stay on the PGEbet app for over 1 hour every day for 7 consecutive days to win 100 rupees.',
    promotionDuration: 'Promotion Duration: ',
    duration1: '1 month',
    title7: 'Sports 2023 Promotion',
    desc7_1: 'Use your 100% Deposit Bonus!',
    desc7_2: 'No Deposit limits on all sports including Football and Cricket games!',
    title8: 'Christmas Holiday Special',
    desc8_1: 'Grab your PGE Gift for December!',
    desc8_2: 'Deposits in December will receive 150% bonus. Ends Christmas night.',
    button_text8: 'Deposit Now',
    button_nav8: 'Deposit',
    title9: 'VIP Club Bonus',
    desc9_1: 'Join VIP Club and get Bonus on Every Deposit!',
    desc9_2: '100% Bonus for VIP members',
    desc9_3: '150% Bonus for SVIP members',
    button_text9: 'Join VIP Club',
    button_nav9: 'VIP'
  },
  notice: {
    title1: 'Blackjack - A Fun Game of 21',
    subTitle1: 'Win Big Money Today!',
    text1_1: 'Quick games played every minute. Easy to play and all Bonus Promotions can be used.',
    title2: 'Baccarat - So Easy to Play!',
    subTitle2: 'Bet on the Banker or Player',
    text2_1: 'Quick games and all Bonus Promotions can be used.',
    title3: 'Roulette - So Entertaining!',
    subTitle3: 'Easy to play and played around the world.',
    text3_1: 'If the ball lands on your number you win 35 times your bet!',
    title4: 'Sports Betting 24/7',
    subTitle4: 'Can also \'Sell your Bets\'. Play to find out more!\n',
    text4_1: 'Includes cricket, soccer and sports around the world.',
    title5: 'Roulette Tutorial',
    subTitle5: 'Watch this video and learn how to play. Easy and fun.',
    text5_1: 'If the ball lands on your number you win 35 times your bet!',
    titleAndar: 'Andar Bahar Competition',
    subTitleAndar: 'Play Andar Bahar Live and Win ₹1 Million Monthly Prize!',
    textAndar_1: 'Competition Starts on 1st March 2022! Stay Tuned!',
    buttonAndar: 'My Ranking',
    titleBlackjack: 'Blackjack Tutorial',
    subTitleBlackjack: 'One of the most popular casino games in the world.',
    textBlackjack: 'Just beat the dealer and you win! Easy to learn and fun to play.'
  },
  winner: {
    justWon: 'just won',
    playing: 'playing',
    live: 'Live',
    players: 'Players'
  },
  login: {
    login: 'Log In',
    tooOften: 'Please retry after {seconds}s',
    register: 'Register',
    recover: 'Recover Password',
    reset: 'Reset Password',
    birthday: 'Birthday',
    email: 'Email',
    password: 'Password',
    continue: 'or continue with',
    forget: 'Forget password',
    username: 'User Name',
    Username: 'Username',
    invalid: 'Invalid Mobile Number',
    depositCur: 'Deposit Currency',
    Recover: 'Recover',
    Reset: 'Reset',
    Submit: 'Submit',
    mobileNumber: 'Mobile Number',
    inviteCode: 'Invite Code (Optional)',
    snsPrompt1: 'Code has been sent to',
    snsPrompt2: 'Please enter the code to login.',
    incorrectCode: 'Incorrect code',
    resendCode: 'Resend Code',
    abnormalPrompt1: 'Your account has been suspended due to abnormal activities. Please contact',
    abnormalPrompt2: 'or',
    abnormalPrompt3: 'live support',
    abnormalPrompt4: 'if you have any questions.',
    codeExpired: 'The code has expired',
    invalidCode: 'Invalid SNSCode',
    newPassword: 'New Password',
    couponCode: 'Coupon Code (Optional)',
    slogan: 'Get ₹{amount} Now!',
    attention1: 'India\'s No.1 Online Betting Site.',
    attention2: 'Log in now for instant gifts and other bonuses.',
    toast10002: 'Account violation. Login banned.'
  },
  message: {
    readAll: 'Read All',
    emailActivate: 'Error occurs when activate email',
    inputEmail: 'Please input email',
    inputPassword: 'Please input password',
    inputUsername: 'Please input user name',
    inputValid: 'Please input valid email address',
    passwordMust: 'Password must be 8-18 bit and include number, alphabet and special character',
    notRegister: 'This email is not register',
    notCorrect: 'Password is not correct',
    registerSuccess: 'Register successfully',
    usernameExit: 'Username existed',
    emailExit: 'Email existed',
    mobileExit: 'Mobile existed',
    accountSuspended: 'Your account has been suspended due to abnormal activities. Please contact support@pgebet.com',
    registerFail: 'Fail. Please retry or contact support@pgebet.com',
    claimSuccess: 'Congrats!you get ',
    claimCash: 'cash',
    cannotClaimed: 'Sorry, rewards can\'t be repeatedly received.',
    claimed: 'claimed',
    MessageDetail: 'Message Detail'
  },
  active: {
    emailActive: 'Email Active',
    activating: 'Activating your email'
  },
  account: {
    outLink: 'Find IFSC Code >>',
    totalBalance: 'Total Balance',
    cash: 'Cash',
    safe: 'Safe',
    safeWallet: 'Safe Wallet',
    extra: 'Extra',
    deposit: 'Deposit',
    transfer: 'Transfer',
    transferTo: 'Transfer to',
    safeBalance: 'Safe Balance',
    deposited: 'deposited',
    withdrew: 'withdrew',
    safeOnlyForDeposit: 'Safe feature is only available for deposited customers',
    inputAmount: 'Input amount to transfer',
    giftAmount: 'Gift amount',
    transferExceedLimit: 'Transfer amount exceeds the limit: ',
    transferSuccess: 'Transfer success',
    transferFail: 'Transfer fail',
    transferError: 'Transfer error',
    betThenWithdraw: 'Bet {bet} and withdraw <span style="color: #D0D6D9;font-size: 18px;font-weight: bold">{withdraw}</span>',
    withdraw: 'Withdraw',
    affiliate: 'Affiliate',
    bonus: 'Bonus',
    completedBonus: 'Completed Bonus',
    claim: 'Claim',
    invite: 'Invite Link',
    copy: 'Copy Link',
    copyCode: 'Copy Code',
    cashBalance: 'Cash Balance',
    apply: 'Receive',
    depositBonus: ' Deposit Bonus',
    agree: 'I agree with the terms and conditions',
    submit: 'Submit',
    amount: 'Amount',
    cardInvalid: 'Invalid. <br> Please update.',
    selectAmount: 'Please select an amount',
    withdrawalRules: 'Withdrawal Rules',
    withdrawalRuleList:
      '<div style="margin: 12px 0">1. Up to 5 withdrawals per day.' +
      '<div style="margin: 12px 0">2. Withdrawal Fee:' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;① 0 withdrawal fee for the first two withdrawals per day;' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;② After two withdrawals, INR 250 will be charged if the amount is INR 5,000 or below;' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;③ After two withdrawals, 18% fee will be charged if the amount is higher than INR 5,000.' +
      '<div style="margin: 12px 0">3. The deposit amount must be rolled over at least 1 times. For example, if you deposit INR 500 and make two bets of INR 250, your maximum withdrawalable balance will be INR 500.',
    withdrawalRuleListB:
      '<div style="margin: 12px 0">1. Up to 5 withdrawals per day.' +
      '<div style="margin: 12px 0">2. Withdrawal Fee:' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;① 0 withdrawal fee if the amount is INR 5,000 or below.' +
      '<div style="margin: 12px 0">&nbsp;&nbsp;② After 3 withdrawals, 11% fee will be charged if the amount is higher than INR 5,000.' +
      '<div style="margin: 12px 0">3. The deposit amount must be rolled over at least 1 times. For example, if you deposit INR 500 and make two bets of INR 250, your maximum withdrawalable balance will be INR 500.',
    withdrawalRuleListC:
      '<div style="margin: 12px 0">1. Up to 5 withdrawals per day.' +
      '<div style="margin: 12px 0">2. No withdrawal fees!' +
      '<div style="margin: 12px 0">3. The deposit amount must be rolled over at least 1 times. For example, if you deposit INR 500 and make two bets of lNR 250, your maximum withdrawalable balance will be lNR 500.',
    withdrawalRuleListD:
      '<div style="margin: 12px 0">1. Up to 5 withdrawals per day.' +
      '<div style="margin: 12px 0">2. No withdrawal fees!' +
      '<div style="margin: 12px 0">3. Request needs to be submitted one by one, meaning a new request can only be submitted after the previous one is approved.' +
      '<div style="margin: 12px 0">4.The deposit amount must be rolled over at least 1 times. For example, if you deposit INR 500 and make two bets of lNR 250, your maximum withdrawalable balance will be lNR 500.',
    wallet: 'My Wallet',
    accountName: 'Account Name',
    accountNo: 'Account Number',
    IFSC: 'Bank Code (IFSC Code)',
    check: 'Check Agreement',
    outRange: 'Invalid amount, out of range',
    notEnough: 'No enough balance available',
    copySuccess: 'Copy Success',
    gateway: 'Gateway',
    withdrawableBalance: 'Withdrawable Balance',
    notWithdrawable: 'is not withdrawable',
    yourID: 'Your ID',
    upload: 'Upload',
    view: 'View',
    set: 'Set',
    bankAccount: 'Bank Account',
    rules: 'Rules',
    myRewards: 'My Rewards',
    friends: 'Friends',
    total: 'Total',
    rewards: 'Rewards',
    stepsToEarn: 'Steps to Earn',
    noRewardSharePrompt: 'No rewards yet? Share the link below to earn your commission right now!',
    joined: 'Joined',
    inviteRewards: 'Invite Rewards',
    depositRewards: 'Deposit Rewards',
    lastPlayed: 'Last Played',
    lastDeposit: 'Last Deposit',
    whatsapp: 'Whatsapp',
    selectDepositAmount: 'Please select deposit amount',
    selectUPIChannel: 'Please select UPI channel',
    needLogin: 'Please login firstly',
    promptToSetID: 'Please set your id before withdraw',
    promptToSubmitID: 'Please submit your id before withdraw',
    promptToSubmitBankAccount: 'Please submit your bank account before withdraw',
    selectWithdrawAmount: 'Please select withdraw amount',
    withdrawSetup: {
      personalInfo: 'Personal info',
      idDocument: 'ID Document',
      textPromptToUpgrade: 'If you have problem uploading photos, please tap to copy and paste the link below to your browser to download and install the latest version of the app.',
      copyLnk: 'Copy Link',
      textFrontSide: 'Front Side of Your Aadhaar Card',
      textBackSide: 'Back Side of Your Aadhaar Card',
      textPhoto: 'Photo of Yourself holding Aadhaar Card',
      textFullName: 'Full Name',
      textBirthday: 'Birthday',
      textCardNumber: 'Aadhaar Card Number',
      textMobileNumber: 'Mobile Number',
      textYourBank: 'Select Bank Account',
      promptFillName: 'Please fill in your full name',
      promptFillBirthday: 'Please fill in your birthday in correct format dd-mm-yyyy, e.g. 31-01-1998',
      promptFillCard: 'Please fill in your Aadhaar card number',
      promptCardInvalid: 'Aadhaar card number is invalid',
      promptUploadFrontCard: 'Please upload the front side of your Aadhaar card',
      promptUploadBackCard: 'Please upload the back side of your Aadhaar card',
      promptUploadPhoto: 'Please upload the photo with yourself holding your Aadhaar card',
      errorUpload: 'Error occurred when uploading. Please try again.',
      promptInvalidAccountName: 'Account name must be in English letters',
      promptInvalidCard: 'Bank code (IFSC code) is invalid',
      promptInvalidAccount: 'Account number is invalid',
      promptFillAccountName: 'Please fill in account name',
      promptFillAccountNumber: 'Please fill in account number',
      promptFillIFSC: 'Please fill in bank code (IFSC code)'
    },
    claimAmount: 'Claim Amount',
    vip: {
      vip: 'VIP',
      svip: 'SVIP',
      myVipStatus: 'My VIP status',
      vipRules: 'Rules',
      currentVIPStatus: 'Current VIP Status',
      offer: 'OFFER',
      bonus: 'BONUS',
      everyDeposit: 'EVERY DEPOSIT',
      condition: 'CONDITION',
      singleDeposit: 'Single Deposit',
      monthlyDeposit: 'Monthly Deposit',
      deposit: 'Deposit',
      or: 'OR',
      vipPrompt: 'Become VIP to receive massive bonus',
      rules: [
        'When you become a PGEbet VIP member, you will receive 100% bonus on every deposit you make!',
        'When you become a PGEbet SVIP (Super VIP) member, you will receive 150% bonus on every deposit you make!',
        'Make one single deposit over ₹5,000 or deposit over a total of ₹20,000 for the current month to become a VIP instantly. You will receive your bonus immediately from your last deposit.',
        'Make one single deposit over ₹10,000 or deposit over a total of ₹50,000 for the current month to become a SVIP instantly. You will receive your bonus immediately from your last deposit.',
        'Your VIP/SVIP membership expires on the last day of every month. Make your required deposits at the start of the next month to become a VIP/SVIP again.'
      ]
    },
    noBonusReadyForClaim: 'No bonus is ready for claim to cash currently',
    bonusWagering: 'Bonus Wagering Requirements',
    bonusPrompt: 'My Bonus | How Does Bonus Work',
    claimBonus: 'Claim Bonus',
    bonusRequirement: 'Wagering',
    howDoesBonusWork: 'How does it work?',
    howDoesBonusWorkItems: [
      'A Bonus is an exclusive offer to PGEbet players.',
      'We credit a Bonus to your account based on promotion terms. For example on a 150% First Deposit Bonus promotion, a ₹100 deposit would get an additional ₹150 in bonus money. Go to \'My Wallet\' to see the Bonus amount. ',
      'A certain amount of your bonus money is converted when you make a bet (wager). The more you bet or wager, the faster your bonus is converted. On the App the converted balance is the \'B\' balance at the top. ',
      'You can Claim the converted bonus balance (B\' balance) any time rather than wait until the entire bonus is converted. Once you Claim it will be transferred to your Cash Balance and available to withdraw.'
    ],
    whatIsBonus: 'What is Wagering Requirement?',
    whatIsBonusContent: 'Wagering Requirement as it is often referred to is the value amount you need to bet in order for your bonus balance to convert to real money and become eligible to withdraw. For example: If a player deposits ₹1,000 with a 100% Bonus and that bonus has a 40X wagering requirement, that would mean your bonus balance credited to your account (₹1,000) can only be converted and claimed to your Cash Account if you have wagered or played 40X (40 times) your bonus amount.' +
      '<div style="margin-top: 10px;">₹1,000 Deposit on a 100% Deposit Bonus Promotion = ₹1,000 Bonus Amount' +
      '<div style="margin-top: 10px;">In this example, ₹1,000 Bonus Amount X 40 is your wagering requirement = ₹40,000' +
      '<div style="margin-top: 10px;">Once you have made ₹40,000 worth of bets (for example could be 10 bets of ₹4,000 each) with your Cash Balance, your bonus amount will fully convert (see progress in \'B\' balance). You can Claim the \'B\' balance amount to your main Cash Balance and then you are eligible to withdraw your funds. ' +
      '<div style="margin-top: 10px;">Please note you do not have to wait until the full bonus amount is converted. Every Rupee that is bet will convert the bonus amount at a rate of 40/40.' +
      '<div style="margin-top: 10px;">So:' +
      '<div style="margin-top: 10px;">If you bet ₹40 with your Cash Balance, your converted bonus is 40/40 = ₹1' +
      '<div style="margin-top: 10px;">After you bet ₹10,000 worth in total, your converted bonus is 10,000/40 = ₹250' +
      '<div style="margin-top: 10px;">You can see your bonus converting progress in \'B\' balance at the top menu. You can Claim any \'B\' balance amount at any time to your Cash Balance and withdraw.' +
      '<div style="margin-top: 10px;">For more info, view our Terms and Conditions page.',
    gameProviders: [
      {
        name: 'Teen Patti',
        provider: 'Jili'
      },
      {
        name: 'AK47',
        provider: 'Jili'
      },
      {
        name: 'Andar Bahar',
        provider: 'Jili'
      },
      {
        name: 'Rummy',
        provider: 'Jili'
      }
    ],
    convertBonusSuccess_1: 'You have successfully converted ',
    convertBonusSuccess_2: 'bonus to your cash balance.',
    readyForClaim: 'Ready for claim to Cash',
    bonusBalance: 'Bonus Balance',
    moreBonus: 'More Bonus',
    isHot: 'Hot',
    currencyType: '₹',
    recommended: 'Recommended',
    yesWithdraw: 'Submit',
    noWithdraw: 'Cancel'
  },
  setting: {
    setting: 'SETTING',
    myInfo: 'MY INFO',
    mobile: 'Mobile Number',
    depositCurrency: 'Deposit Currency',
    save: 'Save',
    saveSuccess: 'Save Success',
    usernameExist: 'Username Exist',
    incorrectBirthday: 'Please enter your birthday in format dd-mm-yyyy, e.g. 31-01-2000',
    myHistory: 'MY HISTORY',
    status: 'status',
    system: 'System',
    event: 'Event',
    personal: 'Personal',
    logout: 'Log Out',
    birthdayTip: '* Cannot be modified after saving'
  },
  privacy: [
    {
      class: 't2',
      content: 'Your privacy is important to us. It is the policy of PGEbet to respect your privacy regarding any information we may collect from you across our site, https://www.pgebet.com, and other sites we own and operate, including the PGEbet App.'
    },
    {
      class: 't2',
      content: 'We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.'
    },
    {
      class: 't2',
      content: 'We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.'
    },
    {
      class: 't2',
      content: 'We don\'t share any personally identifying information publicly or with third-parties.'
    },
    {
      class: 't2',
      content: 'Our site may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.'
    },
    {
      class: 't2',
      content: 'You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.'
    },
    {
      class: 't2',
      content: 'Your continued use of our online casino/site will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.'
    },
    {
      class: 't2',
      content: 'This policy is effective as of 12 July 2020.'
    }
  ],
  responsible: [
    {
      class: 't0',
      content: 'Responsible Gaming '
    },
    {
      class: 't2',
      content: 'Please read this information carefully for your own benefit. '
    },
    {
      class: 't2',
      content: 'PGEbet is operated by Primetime Gaming and Entertainment N.V. having its office at Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao. Company Registration number 160961.'
    },
    {
      class: 't2',
      content: '<i>Interpretation</i>'
    },
    {
      class: 't2',
      content: 'The words of which the initial letter is capitalized have meanings defined under the following conditions.'
    },
    {
      class: 't2',
      content: 'The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.'
    },
    {
      class: 't2',
      content: '<i>Definitions</i>'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Account means a unique account created for You to access our Service or parts of our Service.'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Primetime Gaming and Entertainment N.V.'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Service refers to the Website.'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Website refers to www.pgebet.com or associated sites/apps.'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.'
    },
    {
      class: 't1',
      content: 'Responsible Gambling and Self Exclusion'
    },
    {
      class: 't2',
      content: 'Gambling means for the majority of our Users, entertainment, fun and excitement. But we also know that for some of our Users gambling has negative side effects. '
    },
    {
      class: 't2',
      content: 'Since inception we have contemplated this problem and have tried out best to help if required. Under “Responsible Gambling” we understand multiple steps of measures, with which a gambling provider can help to lower the possibility of negative side effects appearing. In case they already appear we also try to take active steps against them. '
    },
    {
      class: 't2',
      content: 'The most important instruments against negative side effects from gambling are knowledge and education about the risks of gambling, to support our Users’ self-control in order to make sure they do not suffer from negative side effects.   '
    },
    {
      class: 't2',
      content: 'In addition you also can take a self-test, if you feel you are addicted to gambling: <a target="_blank" style="color:dark;" href="https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/ ">https://www.begambleaware.org/gambling-problems/do-i-have-a-gambling-problem/ </a>'
    },
    {
      class: 't2',
      content: 'And you can also find additional information about gambling addictions at: <a target="_blank" style="color:dark;" href="https://www.begambleaware.org/safer-gambling/">https://www.begambleaware.org/safer-gambling/</a> '
    },
    {
      class: 't2',
      content: 'At PGEbet we offer platforms and services that allow our customers to enjoy playing games and placing bets. Our goal is to provide a safe, stable environment that will give you a satisfactory and rewarding experience. We encourage our customers to use our services responsibly and in a reasonable manner. We encourage you to have fun and we only recommend it to our customers while having fun. '
    },
    {
      class: 't1',
      content: 'Helpful hints for responsible gambling at PGEbet'
    },
    {
      class: 't2',
      content: 'At PGEbet the well-being of customers is extremely important. We take our gambling role very seriously and advise you to: '
    },
    {
      class: 't2',
      content: '1. Treat your betting and gaming as a form of entertainment and use the funds you set for your entertainment only. '
    },
    {
      class: 't2',
      content: '2. Deposit Limits: Do not bet more than the limit that you set. '
    },
    {
      class: 't2',
      content: '3. Don\'t bet with money you can\'t lose. '
    },
    {
      class: 't2',
      content: '4. Don\'t chase your loss. '
    },
    {
      class: 't2',
      content: '5.Don\'t let your bets and/or game play prevent the use of time for other activities. '
    },
    {
      class: 't2',
      content: '6.Take breaks: You should take breaks when tired or can´t concentrate anymore. '
    },
    {
      class: 't2',
      content: '7.Only One Account: To make it easier to have an overview of how much time and money you spend on gambling.  '
    },
    {
      class: 't2',
      content: 'If you have concerns about gambling behaviour or feel that you are unable to follow these guidelines, we encourage you to seek advice from a certified organization that can provide support and advice. '
    },
    {
      class: 't1',
      content: 'Information/Contact and Self-Exclusion'
    },
    {
      class: 't2',
      content: 'In addition, you can contact the staff from PGEbet at Support@PGEbet.com if you wish to discuss our self-exclusion process. Please be aware that accounts that are closed under our self-exclusion policy cannot be cancelled or re-opened for any reason. However, once the self-exclusion period has expired, we will send you an email to inform you that your account is reactivated. “Self-Exclusion” means, that you exclude yourself, out of your own choice, from all gambling services. During Self Exclusion you are not allowed to create a new account and every attempt to create a new account during Self Exclusion is a violation of our Terms of Service and may result in the permanent ban of your original account.  '
    },
    {
      class: 't1',
      content: 'Minor Protection'
    },
    {
      class: 't2',
      content: 'To use our service, you have to be 18 years or older or the minimum legal age for gambling in the jurisdiction in which you live. And permitted by law under the laws that apply to you. To avoid abuse, keep your login data safe from any minors near you. '
    },
    {
      class: 't2',
      content: 'Principally we recommend a filter program to avoid minors, especially children, to access any context on the internet, which is not healthy for them.'
    },
    {
      class: 't2',
      content: 'For parents we can recommend a list of internet filters, to support them: <a target="_blank" style="color:dark;" href="https://famisafe.wondershare.com/internet-filter/best-internet-filters.html">https://famisafe.wondershare.com/internet-filter/best-internet-filters.html</a>'
    }
  ],
  terms: [
    {
      class: 't0',
      content: 'Terms and Conditions'
    },
    {
      class: 't1',
      content: '1. Introduction'
    },
    {
      class: 't2',
      content: 'These terms and conditions and the documents referred to below (the "Terms") apply to the use of the current website (the "Website") and its related or connected services (collectively, the "Service") including the PGEbet App.'
    },
    {
      class: 't2',
      content: 'You should carefully review these Terms as they contain important information concerning your rights and obligations concerning the use of the Website and form a binding legal agreement between you - our customer (the "Customer"), and us. By using this Website and/or accessing the Service, you, whether you are a guest or a registered user with an account (“Account”), agree to be bound by these Terms, together with any amendments, which may be published from time to time. If you do not accept these Terms, you should refrain from accessing the Service and using the Website.'
    },
    {
      class: 't2',
      content: 'The Service is owned by Primetime Gaming and Entertainment N.V, a limited liability company registered in Curacao with company registration number 160961 and registered address at Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao (“Company”).'
    },
    {
      class: 't1',
      content: '2. General Terms'
    },
    {
      class: 't2',
      content: 'We reserve the right to revise and amend the Terms (including any documents referred to and linked to below) at any time. You should visit this page periodically to review the Terms and Conditions. Amendments will be binding and effective immediately upon publication on this Website. If you object to any such changes, you must immediately stop using the Service. Your continued use of the Website following such publication will indicate your agreement to be bound by the Terms as amended. Any bets not settled prior to the changed Terms taking effect will be subject to the pre-existing Terms.'
    },
    {
      class: 't1',
      content: '3. Your Obligations'
    },
    {
      class: 't2',
      content: 'You acknowledge that at all times when accessing the Website and using the Service:'
    },
    {
      class: 't2',
      content: '3.1. You are over 18, or the legal age at which gambling, or gaming activities are allowed under the law or jurisdiction that applies to you. We reserve the right to request proof of age documents from you at any time.'
    },
    {
      class: 't2',
      content: '3.2. You are of legal capacity and can enter into a binding legal agreement with us. You must not access the Website or utilize the Service if you are not of legal capacity.'
    },
    {
      class: 't2',
      content: '3.3. You are a resident in a jurisdiction that allows gambling. You are not a resident of any country in which access to online gambling to its residents or to any person within such country is prohibited. It is your sole responsibility to ensure that your use of the service is legal.'
    },
    {
      class: 't2',
      content: '3.4. You may not use a VPN, proxy or similar services/devices that mask or manipulate the identification of your real location.'
    },
    {
      class: 't2',
      content: '3.5. You are the authorized user of the payment method you use.'
    },
    {
      class: 't2',
      content: '3.6. You must make all payments to us in good faith and not attempt to reverse a payment made or take any action which will cause such payment to be reversed by a third party.'
    },
    {
      class: 't2',
      content: '3.7. When placing bets you may lose some or all of your money deposited to the Service in accordance with these Terms and you will be fully responsible for that loss.'
    },
    {
      class: 't2',
      content: '3.8. When placing bets you must not use any information obtained in breach of any legislation in force in the country in which you were when the bet was placed.'
    },
    {
      class: 't2',
      content: '3.9. You are not acting on behalf of another party or for any commercial purposes, but solely on your own behalf as a private individual in a personal capacity.'
    },
    {
      class: 't2',
      content: '3.10. You must not either attempt to manipulate any market or element within the Service in bad faith nor in a manner that adversely affects the integrity of the Service or us.'
    },
    {
      class: 't2',
      content: '3.11. You must generally act in good faith in relation to us of the Service at all times and for all bets made using the Service.'
    },
    {
      class: 't1',
      content: '4. Restricted Use'
    },
    {
      class: 't2',
      content: '4.1. You must not use the Service:'
    },
    {
      class: 't2',
      content: '4.1.1. If you are under the age of 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you) or if you are not legally able to enter into a binding legal agreement with us or you acting as an agent for, or otherwise on behalf, of a person under 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you);'
    },
    {
      class: 't2',
      content: '4.1.2. If you reside in a country in which access to online gambling to its residents or to any person within such country is prohibited.'
    },
    {
      class: 't2',
      content: '4.1.3. If you are a resident of one of the following countries, or accessing the Website from one of the following countries:'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>United States of America and its territories,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>France and its territories,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Netherlands and its territories and countries that form the Kingdom of Netherlands, including Bonaire, Sint Eustatius, Saba, Aruba, Curaçao and Sint Maarten,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Australia and its territories,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>United Kingdom of Great Britain and Northern Ireland,'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Spain'
    },
    {
      class: 't2',
      content: '4.1.4. To collect nicknames, e-mail addresses and/or other information of other Customers by any means (for example, by sending spam, other types of unsolicited emails or the unauthorised framing of, or linking to, the Service);'
    },
    {
      class: 't2',
      content: '4.1.5. to disrupt or unduly affect or influence the activities of other Customers or the operation of the Service generally;'
    },
    {
      class: 't2',
      content: '4.1.6. to promote unsolicited commercial advertisements, affiliate links, and other forms of solicitation which may be removed from the Service without notice;'
    },
    {
      class: 't2',
      content: '4.1.7. in any way which, in our reasonable opinion, could be considered as an attempt to: (i) cheat the Service or another Customer using the Service; or (ii) collude with any other Customer using the Service in order to obtain a dishonest advantage;'
    },
    {
      class: 't2',
      content: '4.1.8. to scrape our odds or violate any of our Intellectual Property Rights; or'
    },
    {
      class: 't2',
      content: '4.1.9. for any unlawful activity whatsoever.'
    },
    {
      class: 't2',
      content: '4.2. You cannot sell or transfer your account to third parties, nor can you acquire a player account from a third party.'
    },
    {
      class: 't2',
      content: '4.3. You may not, in any manner, transfer funds between player accounts.'
    },
    {
      class: 't2',
      content: '4.4. We may immediately terminate your Account upon written notice to you if you use the Service for unauthorised purposes. We may also take legal action against you for doing so in certain circumstances.'
    },
    {
      class: 't2',
      content: '4.5. Employees of Company, its licensees, distributors, wholesalers, subsidiaries, advertising, promotional or other agencies, media partners, contractors, retailers and members of the immediate families of each are NOT allowed to use the Service for real money without prior consent from a Company Director. Should such activity be discovered, the account(s) will be immediately terminated and all bonuses/winnings will be forfeited.'
    },
    {
      class: 't1',
      content: '5. Registration'
    },
    {
      class: 't2',
      content: 'You agree that at all times when using the Service:'
    },
    {
      class: 't2',
      content: '5.1. We reserve the right to refuse to accept a registration application from any applicant at our sole discretion and without any obligation to communicate a specific reason.'
    },
    {
      class: 't2',
      content: '5.2. Before using the Service, you must personally complete the registration form and read and accept these Terms. In order to start betting on the Service or withdraw your winnings, we may require you to become a verified Customer which includes passing certain checks. You may be required to provide a valid proof of identification and any other document as it may be deemed necessary. This includes but is not limited to, a picture ID (copy of passport, driver\'s licence or national ID card) and a recent utility bill listing your name and address as proof of residence. We reserve the right to suspend wagering or restrict Account options on any Account until the required information is received. This procedure is done in accordance with the applicable gaming regulation and the anti-money laundering legal requirements. Additionally, you will need to fund your Service Account using the payment methods set out on the payment section of our Website.'
    },
    {
      class: 't2',
      content: '5.3. You have to provide accurate contact information, inclusive of a valid email address (“Registered Email Address”), and update such information in the future to keep it accurate. It is your responsibility to keep your contact details up to date on your Account. Failure to do so may result in you failing to receive important Account related notifications and information from us, including changes we make to these Terms. We identify and communicate with our Customers via their Registered Email Address. It is the responsibility of the Customer to maintain an active and unique email account, to provide us with the correct email address and to advise Company of any changes in their email address. Each Customer is wholly responsible for maintaining the security of his Registered Email Address to prevent the use of his Registered Email Address by any third party. Company shall not be responsible for any damages or losses deemed or alleged to have resulted from communications between Company and the Customer using the Registered Email Address. Any Customer not having an email address reachable by Company will have his Account suspended until such an address is provided to us. We will immediately suspend your Account upon written notice to you to this effect if you intentionally provide false or inaccurate personal information. We may also take legal action against you for doing so in certain circumstances and/or contact the relevant authorities who may also take action against you.'
    },
    {
      class: 't2',
      content: '5.4. You are only allowed to register one Account with the Service. Accounts are subject to immediate closure if it is found that you have multiple Accounts registered with us. This includes the use of representatives, relatives, associates, affiliates, related parties, connected persons and/or third parties operating on your behalf.'
    },
    {
      class: 't2',
      content: '5.5. In order to ensure your financial worthiness and to confirm your identity, we may ask you to provide us with additional personal information, such as your name and surname, or use any third-party information providers we consider necessary. Should any additional personal information be obtained via third-party sources, we will inform you about the data obtained.'
    },
    {
      class: 't2',
      content: '5.6. You must keep your password for the Service confidential. Provided that the Account information requested has been correctly supplied, we are entitled to assume that bets, deposits and withdrawals have been made by you. We advise you to change your password on a regular basis and never disclose it to any third party. It is your responsibility to protect your password and any failure to do so shall be at your sole risk and expense. You may log out of the Service at the end of each session. If you believe any of your Account information is being misused by a third party, or your Account has been hacked into, or your password has been discovered by a third party, you must notify us immediately. You must notify us if your Registered Email Address has been hacked into, we may, however, require you to provide additional information/ documentation so that we can verify your identity. We will immediately suspend your Account once we are aware of such an incident. In the meantime you are responsible for all activity on your Account including third party access, regardless of whether or not their access was authorised by you.'
    },
    {
      class: 't2',
      content: '5.7. You must not at any time transmit any content or other information on the Service to another Customer or any other party by way of a screen capture (or other similar method), nor display any such information or content in a frame or in any other manner that is different from how it would appear if such Customer or third party had typed the URL for the Service into the browser line.'
    },
    {
      class: 't2',
      content: '5.8. When registering, you will receive possibility to use all currencies available on the website. Those will be the currencies of your deposits, withdrawals and bets placed and matched into the Service as set out in these Terms. Some payment methods do not process in all currencies. In such cases a processing currency will be displayed, along with a conversion calculator available on the page.'
    },
    {
      class: 't2',
      content: '5.9. We are under no obligation to open an Account for you and our website sign-up page is merely an invitation to treat. It is entirely within our sole discretion whether or not to proceed with the opening of an Account for you and, should we refuse to open an Account for you, we are under no obligation to provide you with a reason for the refusal.'
    },
    {
      class: 't2',
      content: '5.10. Upon receipt of your application, we may be in touch to request further information and/ or documentation from you in order for us to comply with our regulatory and legal obligations.'
    },
    {
      class: 't1',
      content: '6. Your Account'
    },
    {
      class: 't2',
      content: '6.1. Accounts could use several currencies, in this case all Account balances and transactions appear in the currency used for the transaction.'
    },
    {
      class: 't2',
      content: '6.2. We do not give credit for the use of the Service.'
    },
    {
      class: 't2',
      content: '6.3. We may close or suspend an Account if you are not or we reasonably believe that you are not complying with these Terms, or to ensure the integrity or fairness of the Service or if we have other reasonable grounds to do so. We may not always be able to give you prior notice. If we close or suspend your Account due to you not complying with these Terms, we may cancel and/or void any of your bets and withhold any money in your account (including the deposit).'
    },
    {
      class: 't2',
      content: '6.4. We reserve the right to close or suspend any Account without prior notice and return all funds. Contractual obligations already matured will however be honoured.'
    },
    {
      class: 't2',
      content: '6.5. We reserve the right to refuse, restrict, cancel or limit any wager at any time for whatever reason, including any bet perceived to be placed in a fraudulent manner in order to circumvent our betting limits and/ or our system regulations.'
    },
    {
      class: 't2',
      content: '6.6. If any amount is mistakenly credited to your Account it remains our property and when we become aware of any such mistake, we shall notify you and the amount will be withdrawn from your Account.'
    },
    {
      class: 't2',
      content: '6.7. If, for any reason, your Account goes overdrawn, you shall be in debt to us for the amount overdrawn.'
    },
    {
      class: 't2',
      content: '6.8. You must inform us as soon as you become aware of any errors with respect to your Account.'
    },
    {
      class: 't2',
      content: '6.9. Please remember that betting is purely for entertainment and pleasure and you should stop as soon as it stops being fun. Absolutely do not bet anything you can’t afford to lose. If you feel that you may have lost control of your gambling, we offer a self-exclusion option. Just send a message to our Customer Support Department using your Registered Email Address that you wish to SELF-EXCLUDE and this request will take effect within 24 hours from the moment of its receipt. In this case your account will be disabled until your further notice, and you won’t be able to login to it.'
    },
    {
      class: 't2',
      content: '6.10. You cannot transfer, sell, or pledge Your Account to another person. This prohibition includes the transfer of any assets of value of any kind, including but not limited to ownership of accounts, winnings, deposits, bets, rights and/or claims in connection with these assets, legal, commercial or otherwise. The prohibition on said transfers also includes however is not limited to the encumbrance, pledging, assigning, usufruct, trading, brokering, hypothecation and/or gifting in cooperation with a fiduciary or any other third party, company, natural or legal individual, foundation and/or association in any way shape or form.'
    },
    {
      class: 't2',
      content: '6.11. Should you wish to close your account with us, please send an email from your Registered Email Address to our Customer Support Department via the links on the Website.'
    },
    {
      class: 't1',
      content: '7. Inactive Accounts'
    },
    {
      class: 't2',
      content: '7.1. It is at our discretion to charge you a fee if:'
    },
    {
      class: 't2',
      content: 'You have not logged into your Account or logged out from your Account, or used the Service, or made any bet in any section of the Service after a period of twelve consecutive months or more (Account Activity); and your Account is in credit.'
    },
    {
      class: 't2',
      content: '7.2. You will be notified of any such fee on the eleventh month of inactivity and you will always have the option to log in and withdraw your funds.'
    },
    {
      class: 't2',
      content: '7.3. If the Inactive Account Fee is due to be withdrawn from your Account and the balance of your Account is less than the fee, the Inactive Account Fee shall comprise the remaining funds in your Account.'
    },
    {
      class: 't1',
      content: '8. Deposit of Funds'
    },
    {
      class: 't2',
      content: '8.1. All deposits should be made from an account or payment system or credit card that is registered in your own name, and any deposits made in any other currency will be converted using the daily exchange rate obtained from oanda.com, or at our own bank\'s or our payment processor’s prevailing rate of exchange following which your Account will be deposited accordingly. Note that some payment systems may apply additional currency exchange fees which will be deducted from the sum of your deposit.'
    },
    {
      class: 't2',
      content: '8.2. Fees and charges may apply to customer deposits and withdrawals, which can be found on the Website. In most cases we absorb transaction fees for deposits to your PGEbet Account. You are responsible for your own bank charges that you may incur due to depositing funds with us.'
    },
    {
      class: 't2',
      content: '8.3. Company is not a financial institution and uses a third party electronic payment processors to process credit and debit card deposits; they are not processed directly by us. If you deposit funds by either a credit card or a debit card, your Account will only be credited if we receive an approval and authorisation code from the payment issuing institution. If your card issuer gives no such authorisation, your Account will not be credited with those funds.'
    },
    {
      class: 't2',
      content: '8.4. You agree to fully pay any and all payments and charges due to us or to payment providers in connection with your use of the Service. You further agree not to make any charge-backs or renounce or cancel or otherwise reverse any of your deposits, and in any such event you will refund and compensate us for such unpaid deposits including any expenses incurred by us in the process of collecting your deposit, and you agree that any winnings from wagers utilising those charged back funds will be forfeited. You acknowledge and agree that your player account is not a bank account and is therefore not guaranteed, insured or otherwise protected by any deposit or banking insurance system or by any other similar insurance system of any other jurisdiction, including but not limited to your local jurisdiction. Furthermore, the player account does not bear interest on any of the funds held in it.'
    },
    {
      class: 't2',
      content: '8.5. If you decide to accept any of our promotional or bonus offer/s by entering a bonus code during deposit, you agree to the Terms of each specific bonus.'
    },
    {
      class: 't2',
      content: '8.6. Funds originating from criminal and/or illegal and/or unauthorized activities must not be deposited with us.'
    },
    {
      class: 't2',
      content: '8.7. If you deposit using your credit card, it is recommended that you retain a copy of Transaction Records and a copy of these Terms.'
    },
    {
      class: 't2',
      content: '8.8. Internet Gambling may be illegal in the jurisdiction in which you are located; if so, you are not authorized to use your payment card to deposit on this site. It is your responsibility to know the laws concerning online gambling in your country of domicile.'
    },
    {
      class: 't1',
      content: '9. Withdrawal of Funds'
    },
    {
      class: 't2',
      content: '9.1. You may withdraw any unutilized and cleared funds held in your player account by submitting a withdrawal request in accordance with our withdrawal conditions. '
    },
    {
      class: 't2',
      content: '9.2. We are entitled to deduct withdrawal fees in order to combat money laundering.'
    },
    {
      class: 't2',
      content: '9.3. We reserve the right to request photo ID, address confirmation or perform additional verification procedures (request your selfie, arrange a verification call etc.) for the purpose of identity verification prior to granting any withdrawals from your Account. We also reserve our rights to perform identity verification at any time during the lifetime of your relationship with us.'
    },
    {
      class: 't2',
      content: '9.4. All withdrawals must be made to the original debit, credit card, bank account, method of payment used to make the payment to your Account. We may, and always at our own discretion, allow you to withdraw to a payment method from which your original deposit did not originate. This will always be subject to additional security checks.'
    },
    {
      class: 't2',
      content: '9.5. Should you wish to withdraw funds but your account is either inaccessible, dormant, locked or closed, please contact our Customer Service Department.'
    },
    {
      class: 't2',
      content: '9.6. Minimum withdraw amount is 500 INR. Maximum withdraw amount is 50,000 INR per transaction. 5 withdrawals per person are allowed per day. There are no limits on how much can be withdrawn. Please review our FAQs if any changes to limit amounts have been made temporarily. '
    },
    {
      class: 't2',
      content: '9.7. Please note that we cannot guarantee successful processing of withdrawals or refunds in the event if you breach the Restricted Use policy stated in Clauses 3.3 and 4.'
    },
    {
      class: 't1',
      content: '10. Payment Transactions and Processors'
    },
    {
      class: 't2',
      content: '10.1. You are fully responsible for paying all monies owed to us. You must make all payments to us in good faith and not attempt to reverse a payment made or take any action which will cause such payment to be reversed by a third party in order to avoid a liability legitimately incurred. You will reimburse us for any charge-backs, denial or reversal of payment you make and any loss suffered by us as a consequence thereof. We reserve the right to also impose an administration fee per charge-back, denial or reversal of payment you make.'
    },
    {
      class: 't2',
      content: '10.2. We reserve the right to use third party electronic payment processors and or merchant banks to process payments made by you and you agree to be bound by their Terms and Conditions providing they are made aware to you and those terms do not conflict with these Terms.'
    },
    {
      class: 't2',
      content: '10.3. Suspicious transactions made on our site will be checked to prevent money laundering or terrorism financing activity. Suspicious transactions will be reported to the relevant authority.'
    },
    {
      class: 't1',
      content: '11. Errors'
    },
    {
      class: 't2',
      content: '11.1. In the event of an error or malfunction of our system or processes, all bets are rendered void. You are under an obligation to inform us immediately as soon as you become aware of any error with the Service. In the event of communication or system errors or bugs or viruses occurring in connection with the Service and/or payments made to you as a result of a defect or error in the Service, we will not be liable to you or to any third party for any direct or indirect costs, expenses, losses or claims arising or resulting from such errors, and we reserve the right to void all games/bets in question and take any other action to correct such errors.'
    },
    {
      class: 't2',
      content: '11.2. We make every effort to ensure that we do not make errors in posting bookmaker lines. However, if as a result of human error or system problems a bet is accepted at an odd that is: materially different from those available in the general market at the time the bet was made; or clearly incorrect given the chance of the event occurring at the time the bet was made then we reserve the right to cancel or void that wager, or to cancel or void a wager made after an event has started.'
    },
    {
      class: 't2',
      content: '11.3. We have the right to recover from you any amount overpaid and to adjust your Account to rectify any mistake. An example of such a mistake might be where a price is incorrect or where we enter a result of an event incorrectly. If there are insufficient funds in your Account, we may demand that you pay us the relevant outstanding amount relating to any erroneous bets or wagers. Accordingly, we reserve the right to cancel, reduce or delete any pending plays, whether placed with funds resulting from the error or not.'
    },
    {
      class: 't1',
      content: '12. Rules of Play, Refunds and Cancellations'
    },
    {
      class: 't2',
      content: '12.1. The winner of an event will be determined on the date of the event\'s settlement, and we will not recognize protested or overturned decisions for wagering purposes.'
    },
    {
      class: 't2',
      content: '12.2. All results posted shall be final after 72 hours and no queries will be entertained after that period of time. Within 72 hours after results are posted, we will only reset/correct the results due to human error, system error or mistakes made by the referring results source.'
    },
    {
      class: 't2',
      content: '12.3. If a match result is overturned for any reason by the governing body of the match within the payout period then all money will be refunded.'
    },
    {
      class: 't2',
      content: '12.4. If a draw occurs in a game where a draw option is offered all stakes on a team win or lose will be lost. If a draw option is not offered then everyone receives a refund in the outcome of a draw on the match. And if a draw option has not been made available, then extra time will count, if played.'
    },
    {
      class: 't2',
      content: '12.5. If a result cannot be validated by us, for instance if the feed broadcasting the event is interrupted (and cannot be verified by another source) then at our election, the wagers on that event will be deemed invalid and wagers refunded.'
    },
    {
      class: 't2',
      content: '12.6. Minimum and maximum wager amounts on all events will be determined by us and are subject to change without prior written notice. We also reserve the right to adjust limits on individual Accounts as well.'
    },
    {
      class: 't2',
      content: '12.7. Customers are solely responsible for their own Account transactions. Once a transaction is complete, it cannot be changed. We do not take responsibility for missing or duplicate wagers made by the Customer and will not entertain discrepancy requests because a play is missing or duplicated. Customers may review their transactions in the My Account section of the site after each session to ensure all requested wagers were accepted.'
    },
    {
      class: 't2',
      content: '12.8. A matchup will have action as long as the two teams are correct, and regardless of the League header in which it is placed on our Website.'
    },
    {
      class: 't2',
      content: '12.9. The start dates and times displayed on the Website for Sport matches are an indication only and are not guaranteed to be correct. If a match is suspended or postponed, and not resumed within 72 hours from the actual scheduled start time, the match will have no action and wagers will be refunded. The exception being any wager on whether a team/player advances in a tournament, or wins the tournament, will have action regardless of a suspended or postponed match.'
    },
    {
      class: 't2',
      content: '12.10. If an event is posted by us with an incorrect date, all wagers have action based on the date announced by the governing body.'
    },
    {
      class: 't2',
      content: '12.11. If a team is using stand-ins, the result is still valid as it was the team\'s choice to use the stand-ins.'
    },
    {
      class: 't2',
      content: '12.12. Company reserves the right to remove events, markets and any other products from the Website.'
    },
    {
      class: 't1',
      content: '13. Communications and Notices'
    },
    {
      class: 't2',
      content: '13.1. All communications and notices to be given under these Terms by you to us shall be sent using a Customer Support email on the Website.'
    },
    {
      class: 't2',
      content: '13.2. All communications and notices to be given under these Terms by us to you shall, unless otherwise specified in these Terms, be either posted on the Website and/or sent to the Registered Email Address we hold on our system for the relevant Customer. The method of such communication shall be in our sole and exclusive discretion.'
    },
    {
      class: 't2',
      content: '13.3. All communications and notices to be given under these Terms by either you or us shall be in writing in the English language and must be given to and from the Registered Email Address in your Account.'
    },
    {
      class: 't2',
      content: '13.4. From time to time, we may contact you by email for the purpose of offering you information about betting, unique promotional offerings, and other information from PGEbet. You agree to receive such emails when you agree to these Terms when registering at the Website. You can choose to opt out of receiving such promotional offerings from us at any time by submitting a request to the Customer Support.'
    },
    {
      class: 't1',
      content: '14. Matters Beyond Our Control'
    },
    {
      class: 't2',
      content: 'We cannot be held liable for any failure or delay in providing the Service due to an event of Force Majeure which could reasonably be considered to be outside our control despite our execution of reasonable preventative measures such as: an act of God; trade or labour dispute; power cut; act, failure or omission of any government or authority; obstruction or failure of telecommunication services; or any other delay or failure caused by a third party, and we will not be liable for any resulting loss or damage that you may suffer. In such an event, we reserve the right to cancel or suspend the Service without incurring any liability.'
    },
    {
      class: 't1',
      content: '15. Liability'
    },
    {
      class: 't2',
      content: '15.1. TO THE EXTENT PERMITTED BY APPLICABLE LAW, WE WILL NOT COMPENSATE YOU FOR ANY REASONABLY FORESEEABLE LOSS OR DAMAGE (EITHER DIRECT OR INDIRECT) YOU MAY SUFFER IF WE FAIL TO CARRY OUT OUR OBLIGATIONS UNDER THESE TERMS UNLESS WE BREACH ANY DUTIES IMPOSED ON US BY LAW (INCLUDING IF WE CAUSE DEATH OR PERSONAL INJURY BY OUR NEGLIGENCE) IN WHICH CASE WE SHALL NOT BE LIABLE TO YOU IF THAT FAILURE IS ATTRIBUTED TO: (I) YOUR OWN FAULT; (II) A THIRD PARTY UNCONNECTED WITH OUR PERFORMANCE OF THESE TERMS (FOR INSTANCE PROBLEMS DUE TO COMMUNICATIONS NETWORK PERFORMANCE, CONGESTION, AND CONNECTIVITY OR THE PERFORMANCE OF YOUR COMPUTER EQUIPMENT); OR (III) ANY OTHER EVENTS WHICH NEITHER WE NOR OUR SUPPLIERS COULD HAVE FORESEEN OR FORESTALLED EVEN IF WE OR THEY HAD TAKEN REASONABLE CARE. AS THIS SERVICE IS FOR CONSUMER USE ONLY WE WILL NOT BE LIABLE FOR ANY BUSINESS LOSSES OF ANY KIND.'
    },
    {
      class: 't2',
      content: '15.2. IN THE EVENT THAT WE ARE HELD LIABLE FOR ANY EVENT UNDER THESE TERMS, OUR TOTAL AGGREGATE LIABILITY TO YOU UNDER OR IN CONNECTION WITH THESE TERMS SHALL NOT EXCEED (A) THE VALUE OF THE BETS AND OR WAGERS YOU PLACED VIA YOUR ACCOUNT IN RESPECT OF THE RELEVANT BET/WAGER OR PRODUCT THAT GAVE RISE TO THE RELEVANT LIABILITY, OR (B) 40,000 INR IN AGGREGATE, WHICHEVER IS LOWER.'
    },
    {
      class: 't2',
      content: '15.3. WE STRONGLY RECOMMEND THAT YOU (I) TAKE CARE TO VERIFY THE SUITABILITY AND COMPATIBILITY OF THE SERVICE WITH YOUR OWN COMPUTER EQUIPMENT PRIOR TO USE; AND (II) TAKE REASONABLE PRECAUTIONS TO PROTECT YOURSELF AGAINST HARMFUL PROGRAMS OR DEVICES INCLUDING THROUGH INSTALLATION OF ANTI-VIRUS SOFTWARE.'
    },
    {
      class: 't1',
      content: '16. Gambling By Those Under Age'
    },
    {
      class: 't2',
      content: '16.1. If we suspect that you are or receive notification that you are currently under 18 years or were under 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you) when you placed any bets through the Service your Account will be suspended (locked) to prevent you placing any further bets or making any withdrawals from your Account. We will then investigate the matter, including whether you have been betting as an agent for, or otherwise on behalf, of a person under 18 years (or below the age of majority as stipulated in the laws of the jurisdiction applicable to you). If having found that you: (a) are currently; (b) were under 18 years or below the majority age which applies to you at the relevant time; or (c) have been betting as an agent for or at the behest of a person under 18 years or below the majority age which applies:'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>all winnings currently or due to be credited to your Account will be retained;'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>all winnings gained from betting through the Service whilst under age must be paid to us on demand (if you fail to comply with this provision we will seek to recover all costs associated with recovery of such sums); and/or'
    },
    {
      class: 't2',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>any monies deposited in your Account which are not winnings will be returned to you OR retained until you turn 18 years old at our sole discretion. We reserve the right to deduct payment transaction fees from the amount to return, including transaction fees for deposits to your PGEbet account which we covered.'
    },
    {
      class: 't2',
      content: '16.2. This condition also applies to you if you are over the age of 18 years but you are placing your bets within a jurisdiction which specifies a higher age than 18 years for legal betting and you are below that legal minimum age in that jurisdiction.'
    },
    {
      class: 't2',
      content: '16.3. In the event we suspect you are in breach of the provisions of this Clause or are attempting to rely on them for a fraudulent purpose, we reserve the right to take any action necessary in order to investigate the matter, including informing the relevant law enforcement agencies.'
    },
    {
      class: 't1',
      content: '17. Fraud'
    },
    {
      class: 't2',
      content: 'We will seek criminal and contractual sanctions against any Customer involved in fraud, dishonesty or criminal acts. We will withhold payment to any Customer where any of these are suspected. The Customer shall indemnify and shall be liable to pay to us on demand all costs, charges or losses sustained or incurred by us (including any direct, indirect or consequential losses, loss of profit, loss of business and loss of reputation) arising directly or indirectly from the Customer’s fraud, dishonesty or criminal act.'
    },
    {
      class: 't1',
      content: '18. Intellectual Property'
    },
    {
      class: 't2',
      content: '18.1. Any unauthorised use of our name and logo may result in legal action being taken against you.'
    },
    {
      class: 't2',
      content: '18.2. As between us and you, we are the sole owners of the rights in and to the Service, our technology, software and business systems (the "Systems") as well as our odds. You must not use your personal profile for your own commercial gain (such as selling your status update to an advertiser); and when selecting a nickname for your Account we reserve the right to remove or reclaim it if we believe it appropriate.'
    },
    {
      class: 't2',
      content: '18.3. You may not use our URL, trademarks, trade names and/or trade dress, logos ("Marks") and/or our odds in connection with any product or service that is not ours, that in any manner is likely to cause confusion among Customers or in the public or that in any manner disparages us.'
    },
    {
      class: 't2',
      content: '18.4. Except as expressly provided in these Terms, we and our licensors do not grant you any express or implied rights, license, title or interest in or to the Systems or the Marks and all such rights, license, title and interest specifically retained by us and our licensors. You agree not to use any automatic or manual device to monitor or copy web pages or content within the Service. Any unauthorized use or reproduction may result in legal action being taken against you.'
    },
    {
      class: 't1',
      content: '19. Your License'
    },
    {
      class: 't2',
      content: '19.1. Subject to these Terms and your compliance with them, we grant to you a non-exclusive, limited, non transferable and non sub-licensable license to access and use the Service for your personal non-commercial purposes only. Our license to you terminates if our agreement with you under these Terms ends.'
    },
    {
      class: 't2',
      content: '19.2. Save in respect of your own content, you may not under any circumstances modify, publish, transmit, transfer, sell, reproduce, upload, post, distribute, perform, display, create derivative works from, or in any other manner exploit, the Service and/or any of the content thereon or the software contained therein, except as we expressly permit in these Terms or otherwise on the Website. No information or content on the Service or made available to you in connection with the Service may be modified or altered, merged with other data or published in any form including for example screen or database scraping and any other activity intended to collect, store, reorganise or manipulate such information or content.'
    },
    {
      class: 't2',
      content: '19.3. Any non-compliance by you with this Clause may also be a violation of our or third parties\' intellectual property and other proprietary rights which may subject you to civil liability and/or criminal prosecution.'
    },
    {
      class: 't1',
      content: '20. Your Conduct and Safety'
    },
    {
      class: 't2',
      content: '20.1. For your protection and protection of all our Customers, the posting of any content on the Service, as well as conduct in connection therewith and/or the Service, which is in any way unlawful, inappropriate or undesirable is strictly prohibited (“Prohibited Behaviour”).'
    },
    {
      class: 't2',
      content: '20.2. If you engage in Prohibited Behaviour, or we determine in our sole discretion that you are engaging in Prohibited Behaviour, your Account and/or your access to or use of the Service may be terminated immediately without notice to you. Legal action may be taken against you by another Customer, other third party, enforcement authorities and/or us with respect to you having engaged in Prohibited Behaviour.'
    },
    {
      class: 't2',
      content: '20.3. Prohibited Behaviour includes, but is not limited to, accessing or using the Service to:'
    },
    {
      class: 't2',
      content: 'promote or share information that you know is false, misleading or unlawful;'
    },
    {
      class: 't2',
      content: 'conduct any unlawful or illegal activity, such as, but not limited to, any activity that furthers or promotes any criminal activity or enterprise, violates another Customer\'s or any other third party’s privacy or other rights or that creates or spreads computer viruses;'
    },
    {
      class: 't2',
      content: 'harm minors in any way;'
    },
    {
      class: 't2',
      content: 'transmit or make available any content that is unlawful, harmful, threatening, abusive, tortuous, defamatory, vulgar, obscene, lewd, violent, hateful, or racially or ethnically or otherwise objectionable;'
    },
    {
      class: 't2',
      content: 'transmit or make available any content that the user does not have a right to make available under any law or contractual or fiduciary relationship, including without limitation, any content that infringes a third party’s copyright, trademark or other intellectual property and proprietary rights;'
    },
    {
      class: 't2',
      content: 'transmit or make available any content or material that contains any software virus or other computer or programming code (including HTML) designed to interrupt, destroy or alter the functionality of the Service, its presentation or any other website, computer software or hardware;'
    },
    {
      class: 't2',
      content: 'interfere with, disrupt or reverse engineer the Service in any manner, including, without limitation, intercepting, emulating or redirecting the communication protocols used by us, creating or using cheats, mods or hacks or any other software designed to modify the Service, or using any software that intercepts or collects information from or through the Service;'
    },
    {
      class: 't2',
      content: 'retrieve or index any information from the Service using any robot, spider or other automated mechanism;'
    },
    {
      class: 't2',
      content: 'participate in any activity or action that, in the sole and entire unfettered discretion of us results or may result in another Customer being defrauded or scammed;'
    },
    {
      class: 't2',
      content: 'transmit or make available any unsolicited or unauthorised advertising or mass mailing such as, but not limited to, junk mail, instant messaging, "spam", chain letters, pyramid schemes or other forms of solicitations;'
    },
    {
      class: 't2',
      content: 'create Accounts on the Website by automated means or under false or fraudulent pretences;'
    },
    {
      class: 't2',
      content: 'impersonate another Customer or any other third party, or'
    },
    {
      class: 't2',
      content: 'any other act or thing done that we reasonably consider to be contrary to our business principles.'
    },
    {
      class: 't2',
      content: 'The above list of Prohibited Behaviour is not exhaustive and may be modified by us at any time or from time to time. We reserve the right to investigate and to take all such actions as we in our sole discretion deem appropriate or necessary under the circumstances, including without limitation deleting the Customer’s posting(s) from the Service and/or terminating their Account, and take any action against any Customer or third party who directly or indirectly in, or '
    },
    {
      class: 't2',
      content: 'knowingly permits any third party to directly or indirectly engage in Prohibited Behaviour, with or without notice to such Customer or third party.'
    },
    {
      class: 't1',
      content: '21. Links to Other Websites'
    },
    {
      class: 't2',
      content: 'The Service may contain links to third party websites that are not maintained by, or related to, us, and over which we have no control. Links to such websites are provided solely as a convenience to Customers, and are in no way investigated, monitored or checked for accuracy or completeness by us. Links to such websites do not imply any endorsement by us of, and/or any affiliation with, the linked websites or their content or their owner(s). We have no control over or responsibility for the availability nor their accuracy, completeness, accessibility and usefulness. Accordingly when accessing such websites we recommend that you should take the usual precautions when visiting a new website including reviewing their Privacy Policy and Terms of Use.'
    },
    {
      class: 't1',
      content: '22. Complaints'
    },
    {
      class: 't2',
      content: '22.1. If you have any concerns or questions regarding these Terms you should contact our Customer Service Department via the links on the Website and use your Registered Email Address in all communication with us.'
    },
    {
      class: 't2',
      content: '22.2. NOTWITHSTANDING THE FOREGOING, WE TAKE NO LIABILITY WHATSOEVER TO YOU OR TO ANY THIRD PARTY WHEN RESPONDING TO ANY COMPLAINT THAT WE RECEIVED OR TOOK ACTION IN CONNECTION THEREWITH.'
    },
    {
      class: 't2',
      content: '22.3. If a Customer is not satisfied with how a bet has been settled then the Customer should provide details of their grievance to our Customer Service Department. We shall use our reasonable endeavours to respond to queries of this nature within a few days (and in any event we intend to respond to all such queries within 24 hours of receipt).'
    },
    {
      class: 't2',
      content: '22.4. Disputes must be lodged within three (3) days from the date the wager in question has been decided. No claims will be honoured after this period. The Customer is solely responsible for their Account transactions.'
    },
    {
      class: 't2',
      content: '22.5. In the event of a dispute arising between you and us our Customer Service Department will attempt to reach an agreed solution. Should our Customer Service Department be unable to reach an agreed solution with you, the matter will be escalated to our management.'
    },
    {
      class: 't1',
      content: '23. Assignment'
    },
    {
      class: 't2',
      content: 'Neither these Terms nor any of the rights or obligations hereunder may be assigned by you without the prior written consent of us, which consent will not be unreasonably withheld. We may, without your consent, assign all or any portion of our rights and obligations hereunder to any third party provided such third party is able to provide a service of substantially similar quality to the Service by posting written notice to this effect on the Service.'
    },
    {
      class: 't1',
      content: '24. Severability'
    },
    {
      class: 't2',
      content: 'In the event that any provision of these Terms is deemed by any competent authority to be unenforceable or invalid, the relevant provision shall be modified to allow it to be enforced in line with the intention of the original text to the fullest extent permitted by applicable law. The validity and enforceability of the remaining provisions of these Terms shall not be affected'
    },
    {
      class: 't1',
      content: '25. Breach of These Terms'
    },
    {
      class: 't2',
      content: 'Without limiting our other remedies, we may suspend or terminate your Account and refuse to continue to provide you with the Service, in either case without giving you prior notice, if, in our reasonable opinion, you breach any material term of these Terms. Notice of any such action taken will, however, be promptly provided to you.'
    },
    {
      class: 't1',
      content: '26. General Provisions'
    },
    {
      class: 't2',
      content: '26.1. Term of agreement. These Terms shall remain in full force and effect while you access or use the Service or are a Customer or visitor of the Website. These Terms will survive the termination of your Account for any reason.'
    },
    {
      class: 't2',
      content: '26.2. Gender. Words importing the singular number shall include the plural and vice versa, words importing the masculine gender shall include the feminine and neuter genders and vice versa and words importing persons shall include individuals, partnerships, associations, trusts, unincorporated organisations and corporations.'
    },
    {
      class: 't2',
      content: '26.3. Waiver. No waiver by us, whether by conduct or otherwise, of a breach or threatened breach by you of any term or condition of these Terms shall be effective against, or binding upon us unless made in writing and duly signed by us, and, unless otherwise provided in the written waiver, shall be limited to the specific breach waived. The failure of us to enforce at any time any term or condition of these Terms shall not be construed to be a waiver of such provision or of the right of us to enforce such provision at any other time.'
    },
    {
      class: 't2',
      content: '26.4. Acknowledgement. By hereafter accessing or using the Service, you acknowledge having read, understood and agreed to each and every paragraph of these Terms. As a result, you hereby irrevocably waive any future argument, claim, demand or proceeding to the contrary of anything contained in these Terms.'
    },
    {
      class: 't2',
      content: '26.5. Language. In the event of there being a discrepancy between the English language version of these rules and any other language version, the English language version will be deemed to be correct.'
    },
    {
      class: 't2',
      content: '26.6. Governing Law. These Terms are governed by the law in force in Curaçao.'
    },
    {
      class: 't2',
      content: '26.7. Entire agreement. These Terms constitute the entire agreement between you and us with respect to your access to and use of the Service, and supersedes all other prior agreements and communications, whether oral or written with respect to the subject matter hereof.'
    }
  ],
  faqList: [
    {
      key: 'common',
      label: 'Most Common Questions'
    },
    {
      key: 'deposit',
      label: 'Deposits'
    },
    {
      key: 'withdraw',
      label: 'Withdrawals'
    },
    {
      key: 'account',
      label: 'Account'
    },
    // {
    //   key: 'bonus',
    //   label: 'Bonus'
    // },
    {
      key: 'wagering',
      label: 'Wagering Requirements'
    },
    {
      key: 'support',
      label: 'Technical Support'
    }
  ],
  faqDetailList: {
    common: [
      {
        subTitle: 'How do I make a deposit?',
        content:
          '<div style="margin-bottom: 10px;">Log in to your account and complete the following steps:' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Click on the "DEPOSIT" button.' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Enter deposit amount' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Click "SUBMIT"' +
          '<div style="margin-top: 10px;">Then start playing your favourite games.'
      },
      {
        subTitle: 'What is the lowest amount that I can deposit?',
        content: 'The minimum deposit amount is 100 INR and maximum 50,000 INR per transaction.'
      },
      {
        subTitle: 'How quickly will my deposit be credited to my account?',
        content:
          'The processing time begins instantly.'
      },
      {
        subTitle: 'My deposit was not credited to my account?',
        content:
          'The first thing to do is to refresh your page. If the deposited amount is still not credited, please contact our Live Support team, and one of our representatives will be able to help you.' +
          '<div style="margin: 10px 0;">Please be prepared to provide the following information:' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Which deposit method did you use?' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>When did you make the deposit?' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>What amount was the deposit?' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>What bank are you with?' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Have the funds been withdrawn from the account you made your deposit from? If so, please provide a screenshot of the transaction/bank statement.'
      },
      {
        subTitle: 'Where can I find my deposit history?',
        content:
          'To view this information, simply click on the Account/History button. Here you can view all your past deposits made.'
      }
    ],
    account: [
      {
        subTitle: 'How do I create an Account?',
        content:
          'To register and create an account, click the Log In button, enter your phone number and follow the quick and simple steps.'
      },
      {
        subTitle: 'I am unable to create a new account, because an account has already been created from this device, what do I do?',
        content:
          'Ensure that you don\'t already have an account with us. Keep in mind that we only allow one account per player. If you have created an account with us in the past, we kindly ask you to play on your existing account.' +
          '<div style="margin-top: 10px;">If you cannot remember your login details, please follow the password recovery instructions. If you have never signed up for an account, but your account credentials already exist in our database please contact our Live Support team so we can investigate further.'
      },
      {
        subTitle: 'Where do I see my balance?',
        content:
          'You will find your balance on the top of your screen.'
      }
    ],
    bonus: [
      {
        subTitle: 'Where can I see current Bonus balance?',
        content:
          'You can find your Bonus balance next to "B" symbol at the top bar.'
      },
      {
        subTitle: 'How do I get a Bonus?',
        content:
          'You can click on "Promotion" button at the bottom and check for specific promotions and events. Just read the terms. '
      },
      {
        subTitle: 'How do I use my Bonus?',
        content:
          'After getting the Bonus, every ₹40 bet converts ₹1 Bonus to Cash.' +
          'Note: Some bets in some games cannot convert Bonus to Cash. Please refer to the Bonus Rules for details.'
      },
      {
        subTitle: 'What do I do after my Bonus is converted?',
        content:
          'After your Bonus is converted into Cash, the amount will be automatically added to your Cash Balance.'
      },
      {
        subTitle: 'How do I keep track of my Bonus balance?',
        content:
          'You can click on the "B" symbol on the top bar to view the Bonus page. Click on “History” on the Bonus page to view the Bonus history records.'
      },
      {
        subTitle: 'I have not bet but my Bonus balance decreased. Why?',
        content:
          'Each Bonus has an expiry date and the balance will change accordingly after it expires. The expiry date of a Bonus can be viewed in the event or promotion terms associated with this Bonus, and the expired Bonus can be viewed in the Bonus History Page.'
      }
    ],
    deposit: [
      {
        subTitle: 'How do I make a deposit?',
        content:
          '<div style="margin-bottom: 10px;">Log in to your account and complete the following steps:' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Click on the "DEPOSIT" button.' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Enter deposit amount' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Click "SUBMIT"' +
          '<div style="margin-top: 10px;">Then start playing your favourite games.'
      },
      {
        subTitle: 'What is the lowest amount that I can deposit?',
        content: 'The minimum deposit amount is 100 INR and maximum 50,000 INR per transaction.'
      },
      {
        subTitle: 'How does 3D Secure work?',
        content:
          'Before a deposit can be made, the system authenticates the cardholder by redirecting the cardholder to the browser of the bank that issued the card.' +
          '<div style="margin-top: 10px;">When you make an online transaction with 3D Secure, you are redirected to a webpage from your card issuer, which asks you to enter your PIN or password.'
      },
      {
        subTitle: 'How quickly will my deposit be credited to my account?',
        content:
          'The processing time begins instantly.'
      },
      {
        subTitle: 'My deposit was not credited to my account?',
        content:
          'The first thing to do is to refresh your page. If the deposited amount is still not credited, please contact our Live Support team, and one of our representatives will be able to help you.' +
          '<div style="margin: 10px 0;">Please be prepared to provide the following information:' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Which deposit method did you use?' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>When did you make the deposit?' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>What amount was the deposit?' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>What bank are you with?' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Have the funds been withdrawn from the account you made your deposit from? If so, please provide a screenshot of the transaction/bank statement.'
      },
      {
        subTitle: 'Where can I find my deposit history?',
        content:
          'To view this information, simply click on the Account/History button. Here you can view all your past deposits made.'
      }
    ],
    withdraw: [
      {
        subTitle: 'Can I withdraw my bonus balance?',
        content:
          'The bonus balance cannot be withdrawn if the wagering requirements have not yet been met.'
      },
      {
        subTitle: 'How do I make a withdrawal?',
        content:
          'To make a withdrawal request, click on the ‘Withdraw’ button and follow the steps.'
      },
      {
        subTitle: 'How much can I withdraw?',
        content:
          'Minimum withdraw amount is 500 INR. Maximum withdraw amount is 50,000 INR per transaction. There are no limits on how much can be withdrawn.'
      },
      {
        subTitle: 'When can I withdraw?',
        content:
          'You can submit to withdraw at any time. Withdrawals are processed instantly but may take 24 - 48 hours depending on your bank. For most banks withdrawals are done instantly and same day. '
      }
    ],
    wagering: [
      {
        subTitle: 'What is Wagering Requirement?',
        content:
          'Wagering Requirement as it is often referred to is the value amount you need to bet in order for your bonus balance to convert to real money and become eligible to withdraw. For example: If a player deposits ₹1,000 with a 100% Bonus and that bonus has a 40X wagering requirement, that would mean your bonus balance credited to your account (₹1,000) can only be converted and claimed to your Cash Account if you have wagered or played 40X (40 times) your bonus amount.' +
          '<div style="margin-top: 10px;">₹1,000 Deposit on a 100% Deposit Bonus Promotion = ₹1,000 Bonus Amount' +
          '<div style="margin-top: 10px;">In this example, ₹1,000 Bonus Amount X 40 is your wagering requirement = ₹40,000' +
          '<div style="margin-top: 10px;">Once you have made ₹40,000 worth of bets (for example could be 10 bets of ₹4,000 each) with your Cash Balance, your bonus amount will fully convert (see progress in \'B\' balance). You can Claim the \'B\' balance amount to your main Cash Balance and then you are eligible to withdraw your funds. ' +
          '<div style="margin-top: 10px;">Please note you do not have to wait until the full bonus amount is converted. Every Rupee that is bet will convert the bonus amount at a rate of 40/40.' +
          '<div style="margin-top: 10px;">For example:' +
          '<div style="margin-top: 10px;">If you bet ₹40 with your Cash Balance, your converted bonus is 40/40 = ₹1' +
          '<div style="margin-top: 10px;">After you bet ₹10,000 worth in total, your converted bonus is 10,000/40 = ₹250' +
          '<div style="margin-top: 10px;">You can see your bonus converting progress in \'B\' balance at the top menu. You can Claim any \'B\' balance amount at any time to your Cash Balance and withdraw.' +
          '<div style="margin-top: 10px;">For more info, view our Terms and Conditions page. Note: <i>The converted bonus balance is shown on the mobile App as ‘B’ balance and on the Website it is the ‘trophy’ balance when you hover over your Cash Balance at the top next to your Username.</i>' +
          '<div style="margin-top: 10px;">All games at PGEbet have a wagering requirement of 40X except the non-participating games in the list below:' +
          '<div style="margin-top: 10px;">Teen Patti – Jili' +
          '<div style="margin-top: 10px;">AK47 – Jili' +
          '<div style="margin-top: 10px;">Andar Bahar – Jili' +
          '<div style="margin-top: 10px;">Rummy - Jili'
      }
    ],
    support: [
      {
        subTitle: 'What happens if the game freezes in the middle of a round?',
        content:
          'Should your game freeze at any point in time, you will end up exactly where you left off next time you open the game. If there is no option for you to do so, the round will be completed on the server even if your computer is frozen or the Internet connection stopped working. Any winnings are paid out to your account as usual.'
      },
      {
        subTitle: 'Why are the games running slow?',
        content:
          'Make sure you have the latest version of your browser installed (we recommend Google Chrome) and the latest version of Flash. Also make sure that it is not the Internet connection that is the problem (try to play with the network cable if the wireless connection is not working like it should) and close any background programs that might drain your bandwidth.'
      },
      {
        subTitle: 'Why aren’t my games loading?',
        content:
          'This may mean that you have lost contact with the server. Try to log out and log back in and try again. Sometimes you may need to shut down the browser and start over for the game to load. If the problem persists, please reach out to our Live Support team and one of our representatives will be able to help.'
      },
      {
        subTitle: 'What do I do if I cannot open a game?',
        content:
          'If you receive an error message when trying to open a game, contact our Live Support team and one of our representatives will be able to help you.'
      }
    ]
  },
  aboutUs: [
    {
      class: 't1',
      content: '<span style="font-weight: bold">About Us</span>'
    },
    {
      class: 't2',
      content: 'PGEbet is operated by Primetime Gaming and Entertainment N.V. having its office at Zuikertuintjeweg (Zuikertuin Tower), Willemstad, Curacao. Company Registration number 160961. '
    },
    {
      class: 't2',
      content: 'PGEbet is authorized and regulated by the Government of Curacao and operates under License No. 365/JAZ. PGEbet has passed all compliance and is legally authorized to conduct gaming operations for all games of chance and wagering.'
    },
    {
      class: 't2',
      content: 'We are proud of our aim to be the most trusted and secure Online Casino and Sports betting site in India. '
    },
    {
      class: 't1',
      content: '<span style="font-weight: bold">Fair, Safe and Secure</span>'
    },
    {
      class: 't2',
      content: 'When you play at PGEbet, you’re guaranteed a fair, safe and secure Online Betting environment.'
    },
    {
      class: 't2',
      content: 'We’re available 365 days a year and our Customer Support Team is here to ensure your time with us is hassle-free and as enjoyable as possible.'
    },
    {
      class: 't2',
      content: 'So discover the ultimate experience in online gaming and sports betting entertainment. We’re confident that PGEbet will be your favourite place to bet online. We welcome all eligible players from India.'
    }
  ],
  kycPolicy: [
    {
      class: 't0',
      content: 'KYC Policy of Primetime Gaming and Entertainment N.V.'
    },
    {
      class: 't2',
      content: 'When a user requests their first withdrawal of any amount inside the PGEbet Platform, then it is compulsory for them to perform a full KYC process.'
    },
    {
      class: 't2',
      content: 'During this process, the user will have to input some basic details about themselves and then upload:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)A copy of Government Issued Photo ID (in some cases front and back depending on the doc)'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)A selfie of themselves holding the ID doc'
    },
    {
      class: 't2',
      content: 'Once uploaded, the user will get a “Temporarily Approved” Status and the documents will now be on our side, and the “KYC Team” will have 24hrs to go over them and email the user about the outcome:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-Approval'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-Rejection'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>-More information needed – No change in Status'
    },
    {
      class: 't1',
      content: 'Guideline for the “KYC Process”'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)Proof of ID'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.Signature is showing.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.Country is not a Restricted Country: United States of America and its territories, France and its territories, Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao and Sint Maarten, Australia and its territories, United Kingdom of Great Britain, Northern Ireland, Spain. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>c.Full Name matches client’s name.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>d.Document does not expire in the next 3 months.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>e.Owner is over 18 years of age.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)Proof of Residence'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.ID needs to show Proof of Residence (otherwise a Bank Statement or Utility Bill will be required). '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.Country is not a Restricted Country: United States of America and its territories, France and its territories, Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao and Sint Maarten, Australia and its territories, United Kingdom of Great Britain, Northern Ireland, Spain, and Cyprus. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>3)Selfie with ID '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>a.Holder is the same as in the ID document above'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i><i style="margin-left: 20px;"></i>b.ID document is the same as in 1). Make sure photo/ID number is the same.'
    },
    {
      class: 't1',
      content: 'Notes on the “KYC Process”'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)When the KYC process is unsuccessful then the reason is documented and a support ticket is created in the system. The ticket number along with an explanation is communicated back to the user. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)Once all proper documents are in our possession then the account gets approved. '
    },
    {
      class: 't1',
      content: 'Other AML Measures '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>1)If a user has not passed full KYC then they cannot make additional deposits or withdrawals of any amount. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>2)Prior to any withdrawal there is a detailed algorithmic and manual check on the activity and balance of the user to see if the amount withdrawn is a result of proper activity in the platform. '
    },
    {
      class: 't3',
      content: '<i style="margin-left: 20px;"></i>3)Under no circumstances may a user transfer funds directly to another user. '
    }
  ],
  userGuide: {
    homePrompt: 'Play our most popular games',
    depositPrompt: 'Quick deposits. Different options available.',
    withdrawPrompt: 'Withdraw at any time.',
    supportPrompt: 'Live Chat Support 9am – Midnight.',
    giftPrompt: 'Deposit in the next 24 hours and receive a free 1500 Rupee cash bonus to play with. Go to Deposit button to make a deposit.',
    bonusDepositPrompt1: 'Deposit 100 Rupee and receive 150 Rupee bonus.',
    bonusDepositPrompt2: 'Deposit 500 Rupee and receive 750 Rupee bonus.',
    bonusDepositPrompt3: 'Deposit 1000 Rupee and receive 1500 Rupee bonus.'
  },
  loadingStatus: {
    pullToLoad: 'pull to load more',
    releaseToLoad: 'pull to load more',
    loading: 'loading'
  },
  home: {
    gameMaintenancePrompt: 'This game is currently under maintenance. It will be back online in a few moments. Please come back later.',
    gameActivityOnThursday: 'Acitity is coming soon on Thursay.',
    noGameMatchFilter: 'No game matches this filter',
    searchGamePlaceholder: 'Search for Game',
    balance: 'Sorry, your credit is running low!',
    creditNotEnough: 'Sorry, your cash balance is running low,please make a deposit!',
    androidDownload: 'Available on Android. Click here to Download.',
    loading: 'loading',
    downLoadText: ['Download and Get ', '']
  },
  /***
   * 2021-10-10 C007 gift is not used any more, please use deposit gift & daily gift instead
   * **/
  gift: {
    prompt: 'Deposit in the next 24 hours and receive a free 1500 Rupee cash bonus to play with. Go to Deposit button to make a deposit.',
    rule1: 'Deposit 100 Rupee and receive 150 Rupee bonus.',
    rule2: 'Deposit 500 Rupee and receive 750 Rupee bonus.',
    rule3: 'Deposit 1000 Rupee and receive 1500 Rupee bonus.'
  },
  depositGift: {
    textExtra: 'Extra bonus offer on the first deposit',
    text24Hours: '24 hours after register'
  },
  sevenDayGift: {
    textComeBack: 'COME BACK',
    textEveryday: 'EVERY DAY FOR FREE CASH',
    btnDeposit: 'Deposit',
    btnMoreCash: 'More Cash',
    btnCollect: 'Collect Now!',
    btnNextCash: 'NEXT FREE CASH IN',
    makeDeposit: 'You need to successfully deposit once.',
    makeWithdrawal: 'You need to make a successful withdrawal once.',
    invitationNotClicked: 'None of your Referral Invitation links has been clicked.'
  },
  dailyFreeCash: {
    btnCheckIn: 'Check In',
    btnDeposit: 'Deposit',
    btnPlay: 'Play',
    btnCancel: 'Cancel',
    singedText: 'Signed in today',
    giftReward: 'credited to your wallet',
    getExtra: 'Deposit to get extra',
    brownFont: 'fontBrownEn',
    yellowFont: 'fontYellowEn',
    now: 'now'
  },
  history: {
    Balance: 'Balance',
    Rectification: 'Rectification',
    'Return To Zero': 'Return To Zero',
    status: 'status',
    Gift: 'Gift',
    All: 'All',
    Deposit: 'Deposit',
    Withdrawal: 'Withdrawal',
    'Withdrawal Fee': 'Withdrawal Fee',
    'awaiting approval': 'awaiting approval',
    EventGift: 'Event Gift',
    PromotionReward: 'Promotion Reward',
    Bonus: 'Bonus',
    Win: 'Win',
    Freebet: 'Freebet',
    'Freebet Win': 'Freebet Win',
    Bet: 'Bet',
    Rollback: 'Rollback',
    Convert: 'Convert',
    Last7days: 'Last 7 days',
    Last15days: 'Last 15 days',
    Last30days: 'Last 30 days',
    done: 'done',
    rejected: 'rejected',
    processing: 'processing'
  },
  landing1: {
    text11: 'Place your bets with',
    text12: 'PGEbet',
    text21: 'The best online casino in',
    text22: 'India',
    text31: 'Log in now for',
    text32: 'instant ₹100',
    text33: 'gift',
    text41: 'Up to',
    text42: '10,000x',
    text43: 'Winning'
  },
  landing2: {
    text1: 'Place your bets with',
    text2: 'PGEbet',
    text3: 'The best and most popular Online Casino in',
    text4: 'India and Asia',
    text5: 'Log in now for',
    text6: 'instant ₹100 gift',
    text7: 'and other bonuses. Up to',
    text8: '10,000x',
    text9: 'Winning',
    contact: 'Connect with us',
    pgeBet: 'PGEbet',
    forAndroid: 'PGEbet App is available for Android.'
  },
  landing4: {
    text11: 'Place your bets with',
    text12: 'PGEbet',
    text21: 'The best online casino in',
    text22: 'India',
    text31: 'Play games',
    text32: '',
    text33: 'to share the',
    text41: 'weekly',
    text42: '₹100,000',
    text43: 'tournament prize.'
  },
  download: {
    textYou: 'You are Amazing!',
    textDownload: 'Download the app to play',
    textPlace: 'Place your bets with',
    textTheBest: 'The best online casino in ',
    textCountry: 'India',
    textLogin: 'Log in now for',
    textInstant: 'instant ₹100',
    textGift: 'gift',
    textUpto: 'Up to',
    text10000x: '10,000x',
    textWinning: 'Winning'
  },
  share: {
    textCongratulation: 'Congratulation!',
    textPlace: 'Place your bets with',
    textTheBest: 'The best online casino in India',
    textRegisterNow: 'Register now for instant ₹100 gift',
    textUpto: 'Up to 10,000x Winning',
    btnStart: 'Start'
  },
  versionUpdate: {
    title: 'New Version!',
    sentence: 'Update to experience the lastest features!',
    textNewVersion: 'New version of PGEbet is available. You will need to download and install the latest version of APK file to experience the latest features.',
    textPleaseUpgrade: 'Please upgrade to the latest version of PGEbet App to able to use this payment gateway.',
    btnClickToDownload: 'Update Now',
    textCopyLnk: 'Or copy link below and paste on your browser to download',
    btnCopyLnk: 'Copy Link to Browser'
  },
  copyRight: 'India: E-30 Fourth Floor, Sector 3, Noida - 201301. © 2022 PGEbet all rights reserved. DM Global Ltd (Company): Eden Island, Mahe, Seychelles.',
  news: {
    readMore: 'Read More'
  },
  gameCompetition: {
    ranking: 'Ranking',
    howToPlay: 'How to play',
    rules: [
      'Tournament Dates：Every Thursday 0:00:00 to the next Wednesday 23:59:59.',
      'Click "Join Now" to Join the tournament.',
      'Valid bets in the game generate scores. Betting ₹100 generates 1 score.',
      'Ranking displays the previous day results and is updated daily.',
      'Prizes are credited to players\' accounts within 5 days after the tournament ends.',
      'Prizes：</br>' +
      'Rank #1 - #10: ₹5,000 for each player. </br>' +
      'Rank #11 - #20: ₹2,000 for each player.</br>' +
      'Rank #21 - #50: ₹1,000 for each player.</br>'
    ],
    ipl: {
      iplRewardNav: 'IPL 2022',
      weeklyBet: 'Weekly Bet',
      cashReward: 'Cash Reward',
      weekBet: 'Week Bet',
      totalBet: 'Total Bet',
      rules: [
        'IPL 2022 is in full swing! To support this year’s IPL, PGEbet is giving out rewards to players who bet on cricket during this period.',
        'Rewards are calculated and given out automatically on a weekly basis.',
        'Any player who has bet a certain amount will receive a fixed amount reward.',
        'Any player who has bet more than 10,000Rs over the entire event period and has received rewards every week will receive an extra reward for 100Rs.'
      ]
    }
  },
  wagering: {
    title: 'Bonus',
    promptAll: 'All games at PGEbet have a wagering requirement of 40X except the non-participating games in the list below:',
    promptFollowing: 'Following games are not participating in Bonus:',
    name: 'Name',
    provider: 'Provider',
    wagering: 'Wagering'
  },
  // 2022-03-10 CHP Bonus页面
  bonus: {
    expire: 'Expire at',
    received: 'Received',
    completed: 'Completed',
    claimed: 'Claimed',
    unclaimed: 'Unclaimed',
    noDataAvailable: 'No data available'
  },
  // 2022-03-13 CHP 召回
  callback: {
    welcome: 'Welcome back!',
    loyal: 'Loyal customers rewards ends in',
    getitnow: 'Get it Now!'
  },
  // 2022-03-17 CHP Bonus活动
  bonusActivity: {
    holi: {
      dailyGoal: 'Daily Goal',
      bet: 'Bet',
      bonus: 'Bonus',
      introduction: 'Up to ₹100,000 Extra Bonus to give out during Holi Festival! Claim your bonus instantly after meeting the betting goal. Choose Daily Goal 1,2 or 3 to win!',
      howDoesTitle: 'How does it work?',
      howDoesItems: [
        'Promotion Period: March 18th to 24rd 2022.',
        'You can choose from one of the three Daily Goals above.',
        'After completing betting requirement on the chosen Daily Goal for the current day, you can collect the bonus accordingly.',
        'Yon can only choose one goal for the current day.',
        'Daily Goal will reset at 00:00am every day and you must complete it before 00:00am next day to collect bonus.'
      ],
      confirmSelect: 'Could you please confirm your selected goal? You will not be able to change your selection afterwards.',
      eventNotStart: 'Event has not started',
      eventEnd: 'Event has ended',
      hasCollectedBonus: 'You have already collected your bonus.',
      notEligible: 'You are not eligible to participate in this event.',
      notCompleted: 'You selected Daily Goal has not been completed yet.',
      selectGoal: 'Please choose Daily Goal 1,2 or 3',
      collect: 'Collect',
      notParticipate: 'You didn\'t participate in this event.'
    }
  },
  // 2022-03-17 CHP MessageBox
  messageBox: {
    confirm: 'Confirm',
    ok: 'Ok',
    cancel: 'Cancel'
  },
  luckyWheel: {
    css: 'en',
    record: 'Record',
    claimBtn: 'Claim',
    claimedBtn: 'Claimed',
    executeBtn: 'Go',
    taskName: {
      check_in: 'Daily Sign-In',
      bet_amount: 'Bet Amount',
      deposit_amount: 'Deposit Amount',
      win_amount: 'Win Amount',
      bet_count: 'No. of Bets',
      win_count: 'No. of Wins',
      deposit_count: 'No. of Deposits',
      on_line: 'Online Minutes',
      invite_count: 'Valid Invitations'
    },
    typeList: [{key: 'all', name: 'All'}, {key: 'gift', name: 'Cash'}, {key: 'discount', name: 'Discount'}],
    dateList: [
      {key: 0, name: 'Today'},
      {key: 3, name: '3 days'},
      {key: 7, name: '7 days'},
      {key: 15, name: '15 days'},
      {key: 30, name: '30 days'}
    ],
    youHave: 'You have',
    moreTimes: 'more chances',
    earnTimes: ['Complete missions', 'to earn chances'],
    ComeBackTomorrow: ['Come back again', 'tomorrow'],
    oneMoreTime: 'Chances +',
    chances: 'Chances',
    acquired: 'Acquired',
    execute: ['Unfinished Mission,', ' Execute Now!'],
    lookForOther: ['This Mission Has', 'Been Completed. ', 'Please Check Others'],
    cash: 'Cash',
    discount: 'Discount',
    deposit: 'Deposit',
    play: 'Play',
    continue: 'Continue',
    cancel: 'Cancel',
    until: 'Valid until ',
    untilEnd: '',
    received: 'Received',
    use: 'Use',
    used: 'Used',
    expire: 'Expire'
  },
  luckyCard: {
    ProbabilltyOfwinning: 'Probabillty of winning',
    Rewards: 'Rewards',
    BUY: 'BUY',
    CollectNow: 'Collect Now'
  },
  inviteFriends: {
    channel: 'Follow Channel',
    inviteMsg: 'Join me in PGEBet to play games and win big! \n' +
      ' \n' +
      ' 1. Click the link to download the PGEBet App: {shareURL} \n' +
      ' 2. Get ₹{amount1} + ₹{amount2} Exclusive Free Cash & Up To ₹{amount3} First Deposit Bonus. \n' +
      ' \n' +
      ' Rummy, Teen Patti, Aviator, Live Casino, Cricket, Slots are waiting for you to play!',
    Affiliate: 'Affiliate',
    inviteFriends: 'Invite Friends',
    lakh: 'Lakh',
    whiteTitle: ['Get ', 'For Every Invite'],
    desc: ['The More Your Invites Bet, The', ' More You Earn'],
    shareNow: 'Share Now',
    shareImage: 'Share Image',
    steps: 'Steps',
    share: 'Share',
    sentenceOne: 'Join PGEBet now',
    sentenceTwo: 'and get ₹50',
    LongPress: 'Long-press to save image',
    otherWays: 'Other ways to share',
    bannerTxtBefore: ' shared a link ',
    bannerTxtAfter: ' minutes ago',
    saveSuccess: 'Saved to album',
    save: 'Save now',
    close: 'Close',
    BetRewards: 'Bet Rewards',
    Lakh: 'Invitees Bet (Lakh)',
    subLakh: 'Sub-invitees\' Bet (Lakh)',
    timeLimited: 'Time-limited',
    FollowChannel: 'Follow Channel',
    ok: 'OK',
    stepsList: [
      {text: 'Share link/image'},
      {text: 'The invitee registers'},
      {text: 'Invite completed deposit/bet'},
      {text: 'Invitee get ₹20. You get ₹50'}
    ],
    RewardsFonts: [
      {text: ['Total', 'Rewards']},
      {text: ['Total', 'Available']},
      {text: ['Total', 'Invited']}
    ],
    inviteesBetRewards: 'Invitees Bet Rewards ',
    rewards: 'My Rewards',
    claim: 'Claim Now',
    details: 'Details',
    success: 'Success',
    congrats: 'Congrats',
    alert1: 'Reward has been claimed. Bet now to get more!',
    alert2: 'Sub-invitees Bet Reward has been claimed.',
    alert3: 'Contact us to claim bet rewards & learn elite earning secrets!',
    alert4: 'Reward claimed. Contact customer service if reward hasn\'t arrived',
    contact: 'Contact Us',
    subBet: 'Sub-invitees Bet',
    copy: 'Copy',
    add: 'Add now',
    valid: 'Valid Invitations',
    invitations: 'Invitations Pending',
    TotalTitle1: 'Total Bet',
    TotalTitle2: 'Total Deposit',
    TotalTitle3: 'Total Rebate',
    notYet: 'Not Yet Deposited',
    lastOnline: 'Last Online ',
    InvitationDate: 'Invitation Date ',
    bubbleTitle: 'Rules',
    bubbleContent: [
      'Users can only get referral rewards if they successfully register through the invitation link.',
      'All invitation rewards need to be claimed manually on this page.',
      'All reward records can be viewed in the invitation details.',
      'Referral rewards may change at any time, please pay attention to check the rules.',
      'If any fraudulent behavior is found when users get referral rewards, the platform will withdraw the rewards and ban the offending account.',
      'Fraudulent behaviors include: using fake accounts to bind invitations, opposite betting, and malicious complaints.',
      'PGEBet has the final right of interpretation. For other terms, please see Terms and Conditions.'
    ]
  },
  lottery: {
    winBSEReward: 'Guess the last digit of the BSE SENSEX closing price and win the Grand Prize!',
    grandWinner: 'Grand Winner',
    luckyWinner: 'Lucky Winner',
    prizePool: 'Prize Pool',
    confirmBet: 'Confirm Bet',
    betsPlaced: 'Bets Placed',
    lastPrize: 'Last Prize',
    history: 'History',
    howToPlay: 'How to Play',
    pleaseSelectNumber: 'Please select a number',
    pleaseSelectAmount: 'Please select the amount you want to bet',
    buySuccess: 'Congrats, you bought the number successfully',
    buyFailed: 'Sorry, something going wrong, please try again later',
    checkYourAccount: 'Please check your account, you might need to login again',
    noEnoughBalance: 'Please make sure you have enough balance',
    noSellingLottery: 'Sorry, no active lottery available right now',
    date: 'Date',
    bigWinner: 'Big Winner',
    luckyUser: 'Lucky User',
    bet: 'Bet',
    win: 'Win',
    close: 'Close'
  },
  agent: {
    apply: 'Apply as Agent',
    name: 'Real Name',
    email: 'Email',
    mobileNumber: 'Mobile Number',
    smsCode: 'SMS Code',
    send: 'Send',
    smsCodeSentSuccess: 'SMS Code Sent Success',
    smsCodeSentTooFrequent: 'SMS Code Sent Too Frequent',
    smsCodeSentFailed: 'SMS Code Sent Failed',
    submit: 'Submit',
    applySuccess: 'Your application received, we will contact you in 3 work days',
    applyFailed: 'Sorry, please check your submitted info or contact our supporter',
    applyDuplicated: 'Your application for becoming an agent is being reviewed. Do not submit your application again',
    incorrectSMSCode: 'Please check your SMS code',
    portfolio: 'Portfolio',
    rewards: 'Rewards',
    qrCode: 'QR Code',
    download: 'Download',
    share: 'Share',
    inviteLink: 'Invite Link',
    copy: 'Copy',
    copySuccess: 'Copied to Clipboard',
    rewardBalance: 'Balance',
    withdraw: 'Withdraw',
    myRewards: 'My Rewards',
    totalRewards: 'Total Rewards',
    inviteRewards: 'Invite Rewards',
    depositRewards: 'Deposit Rewards',
    bettingRewards: 'Betting Rewards',
    emptyTips: 'No data',
    createTime: 'Create Time',
    depositAmount: 'Deposit Amount',
    bettingAmount: 'Betting Amount',
    rules: 'Rules',
    agentSystem: 'Agent System',
    moreSubordinatesTips: 'Detailed information can be viewed in',
    welcomeMessage: 'Join us at PGEBet, Open game at: '
  },
  treasure: {
    rupee1Treasure: '₹1 Treasure',
    emptyTips: 'No data',
    latest: 'Latest',
    treasureHistory: 'History',
    myTreasure: 'My Treasure',
    drawTime: 'Draw Time',
    moneyBack: 'Money Back',
    buy: 'BUY',
    bought: 'Bought',
    pleaseLoginMessage: 'Please Login',
    treasureDoesNotExistMessage: 'The treasure does not exists',
    doesNotOnSaleMessage: 'The treasure is not on sale right now',
    tooManyErrorMessage: 'The number of tickets you are trying to buy has exceeded the purchasing limit',
    invalidNumberMessage: 'Please enter a number',
    rules: 'Rules',
    boughtSingleResultMessage: 'Congrates, you got a ticket to get the treasure!',
    boughtMultipleResultMessage: 'Congrates, you got tickets to get the treasure!',
    ok: 'OK',
    win: 'Win',
    lost: 'Lost',
    winningNumber: 'Winning Number',
    myNumbers: 'My Number(s)>',
    myNumber: 'My Number',
    treasure: 'Treasure',
    status: 'Status',
    submit: 'Submit',
    myHistory: 'My History',
    saveAddressSuccess: 'Your Address Changed'
  },
  confirmWin: {
    deposit: 'Deposit',
    confirm: 'Confirm'
  },
  bigR: {
    rules: 'Rules',
    notBigRday: 'Promotion Period: Friday 00:00~23:59 New Delhi Time.',
    haveDepositOnce: 'Sorry,your bigR deposit is out of times limit!'
  },
  complaints: {
    whatsappNotAllowedEmpty: 'sorry,WhatsApp\'s not allowed to be empty!',
    lengthMustBeTen: 'Sorry,WhatsApp\'s length should be 10!',
    emailNotAllowedEmpty: 'Sorry,Email \'s not allowed to be empty!',
    contentNotAllowedEmpty: 'Sorry,Detail \'s not allowed to be empty!',
    contentLenOutOfLimit: 'Sorry,Detail \'s length is out of limit of 300 characters!',
    onlySummitOnceWinth24h: 'Sorry,Complaint or Suggestion can be summited once within 24 hours!',
    summitedFailed: 'Sorry,failed to summit!',
    summitSucess: 'PGEBET sincerely thank you for your suggestions!'
  },
  support: {
    service: 'Service',
    sevenTwentyforService: '24/7 Service',
    onlineService: 'online service',
    gogo: 'Go >',
    supportEmail: 'support@pgebet.com',
    email: 'Email',
    copy: 'Copy',
    helpNSupport: 'Help & Support',
    FAQ: 'FAQ',
    customerService: 'Customer Service'
  },
  maintenance: {
    attention: 'Attention',
    notice: 'June 7, 04:00 ~ 08:00 will be down for maintenance',
    dearPlayer: 'Dear player! PGEBet is under maintenance, estimated maintenance time: 04:00 ~ 08:00.',
    pleaseWait: 'Please wait patiently for the maintenance to end.',
    thankYou: 'Thank you for your understanding and support!'
  },
  VIP: {
    noGifts: 'No bonus to claim!',
    getOk: 'success!',
    times: ' times',
    vipBenefits: 'VIP Benefits',
    myVIPBenefits: 'My VIP Benefits',
    currentLevel: 'Current Level',
    notActivated: 'Not Activated',
    upgradeBenefits: 'Upgrade for VIP benefits',
    beingHeld: ' privileges are being held',
    enjoyTheMost: 'Enjoy up to ',
    benefits: ' benefits',
    rebets: 'Bet ₹',
    toRelegate: ' more to maintain your level',
    reachedLevel: ' more to reach this level',
    relegated: 'Already Retained Level',
    seeAll: 'View All',
    levelGift: 'Upgrade Bonus',
    cardRebates: 'Card Rebate',
    slotsRebates: 'Slot Rebate',
    fishingRebates: 'Fishing Rebate',
    Offers: 'Exclusive Promotions and Offers',
    manager: 'Dedicated account manager',
    cashAvailable: 'Available Bonus',
    cashReceived: 'Bonus Claimed',
    getItNow: 'Claim Now',
    customerService: 'Contact Exclusive Customer Support',
    recordOfCollection: 'Claim History',
    hot: 'Top Recommendations',
    currentlyAvailable: 'Available to Claim',
    currentRebateRate: 'Cashback Rate',
    extraTimes1: 'You can claim additional ',
    extraTimes2: 'no. of daily withdrawals',
    unavailable1: 'Your current VIP level ',
    unavailable2: 'cannot enjoy',
    birthdayReminder: 'Please provide your date of birth',
    go: 'GO',
    rule: 'Rules',
    benefitsList: [
      {
        mode: 5,
        value: 'Upgrade Bonus',
        desc: 'Receive cash reward everytime you upgrade',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {mode: 5, value: 'Card Rebate', desc: 'Earn Cashback on Card games', bottom: '', isDark: true, amountShow: ''},
      {mode: 5, value: 'Slot Rebate', desc: 'Earn Cashback on Slot games', bottom: '', isDark: true, amountShow: ''},
      {
        mode: 5,
        value: 'Fishing Rebate',
        desc: 'Earn Cashback on Fishing games',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'Sports Rebate',
        desc: 'Earn Cashback on Sports games',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {mode: 5, value: 'Live Rebate', desc: 'Earn Cashback on Live games', bottom: '', isDark: true, amountShow: ''},
      {mode: 5, value: 'Crash Rebate', desc: 'Earn Cashback on Crash games', bottom: '', isDark: true, amountShow: ''},
      {
        mode: 5,
        value: 'Birthday Bonus',
        desc: 'Cash rewarded on your birthday based on your VIP level',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'Weekly Reward',
        desc: 'Cash rewarded weekly based on your VIP level',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'Exclusive Promotions and Offers',
        desc: 'Access exclusive promotional offers based on your VIP level',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'Dedicated account manager',
        desc: 'Enjoy 1v1 service from your dedicated account manager',
        bottom: '',
        isDark: true,
        amountShow: ''
      }, // 9
      {
        mode: 5,
        value: 'More No. of Withdrawals',
        desc: 'You can claim additional no. of daily withdrawals',
        bottom: '',
        isDark: true,
        amountShow: ''
      },
      {
        mode: 5,
        value: 'Premium Holiday Gifts',
        desc: 'Receive gifts during holidays based on your VIP level',
        bottom: '',
        isDark: true,
        amountShow: ''
      }
    ],
    dateList: [
      {key: 0, name: 'Today'},
      {key: 3, name: '3 days'},
      {key: 7, name: '7 days'},
      {key: 30, name: '30 days'}
    ],
    typeList: [
      {key: 'all', name: 'All'},
      {key: 'level_reward', name: 'Upgrade Bonus'},
      {key: 'week_reward', name: 'Weekly Reward'},
      {key: 'game_reward', name: 'Cashback Reward'}]
  },
  sportsBetting: {
    Ranking: 'Ranking',
    Prizes: 'Prizes',
    Value: 'Value',
    sportsTitle: 'Daily Bets',
    title: 'IPL 2024',
    match: 'Match',
    navItems: ['Daily Match Predictions', 'Final Winner Prediction', 'Sports Betting Rankings'],
    endTime: 'Prediction Deadline',
    championTime: 'Prediction Deadline',
    draw: 'Draw',
    count: 'Predictors',
    gameDesc: 'Match Details',
    otherRound: 'Other Matches',
    quizClues: 'Please Pick Winner Team',
    actualConditions: 'Subject to actual amount credited',
    guessNow: 'Play Prediction Now',
    myGuess: 'My Prediction Picks',
    team: 'Teams',
    mayWin: 'Expected Winnings',
    attendCount: 'Participants',
    shareCount: 'Shares',
    result: 'Match Results',
    share: 'Share',
    lastStep: 'Final Step',
    chooseWay: 'Sharing Method',
    guessSuccess: ['Final Step'],
    guessDesc1: ['Share your Bet! ', 'If someone click your link, the bet counts.'],
    guessDesc2: ['Share your Bet!', 'If someone register via your link, the bet counts.'],
    winnerTeam: 'Final Winner Prediction',
    betRank: 'Betting Rankings',
    myPrediction: 'My Prediction Picks',
    notStart: 'Not Started',
    win: 'Correct',
    lose: 'Missed',
    myRank: 'My Ranking',
    notInRank: 'Not on list',
    seeReward: 'View Rewards',
    playerName: 'Username',
    betAmount: 'Total Bet',
    shareMsg: 'Hey! I am predicting on the IPL 2024 winner. Click on the link to participate with me and be in chance to win ₹1,000,000!',
    rules: [
      'Event Duration: March 22nd to May 27th',
      'To Predict Daily Matches: Share your link and get clicks',
      'For Championship Bets: Share your link and get one valid registration',
      'Only sports games count for Sports Betting Rankings',
      'Event data is updated daily',
      'Rewards sent through in-app messages after match results',
      'Strictly no multiple accounts or fraud for rewards; will result in permanent suspension and deposit confiscation',
      'PGEBet has the final say for event rules'
    ]
  },
  withdrawMsg: {
    message1: 'Success!',
    message2: 'Invalid amount, out of range!',
    message3: 'Not enough withdrawable cash!',
    message4: 'Please set your id!',
    message5: 'Please set your bank account!',
    message6: 'You can only submit up to {amount} withdrawals per day!',
    message7: 'Withdrawal fee is zero, confirm to withdraw?',
    message8: 'withdrawal fee is {amount}, confirm to withdraw?',
    message9: 'withdraw error!',
    message10: 'Please wait for the current request to be completed before submitting a new one.'
  },
  diwali: {
    title: 'Happy Holi!',
    title1: 'Get Bonuses Now!',
    title2: '',
    top1: 'Daily Bonus ',
    top2: 'Final Bonus ',
    progress: 'Gift Package',
    btn0: 'Claim now',
    todayProgress: 'Today\'s Gift Package',
    allProgress: 'All',
    btn9: 'Missed',
    btn1: 'Claimed',
    btn02: 'Not yet started',
    rules: 'Promotion Details',
    msg0: 'Unable to claim',
    msg1: 'The event has not started',
    ruleContent: [
      '1.Event time: March 22nd-March 28th',
      '2.Deposit ₹2000 daily to participate. Claim your prize on this page',
      '3.During promotion period, deposit ₹2000 daily to get ₹77 bonus',
      '4.During the promotion period, deposit a total of ₹50,000 to get a bonus of ₹1572',
      '5.In order to withdraw the bonus, the effective betting amount must be 10 times or over the received bonus amount',
      '6.User cannot use multiple accounts or identities. Any fraudulent attempt will result in suspension of account and loss of deposits/balances',
      '7.PGEBet reserves the right of final interpretation for this promotion'
    ]
  },
  cashback: {
    route: 'Cash Back',
    title: 'An exclusive cashback promotion, carefully crafted just for you.',
    tr1: 'Rewards available',
    tr2: 'In Progress',
    cardBtn: 'Claim now',
    cardBtn1: 'Rules'
  },
  taskSign: {
    login: 'Login {Amount} day(s)',
    download_app: 'Download & use the app',
    deposit: 'Deposit ≥ ₹{Amount}',
    withdrawal: 'Withdraw ≥ ₹{Amount}',
    add_bank_account: 'Fill account at "Withdraw"',
    share: 'Valid share',
    rule: '* Finish the task and claim bonus within {Amount} days.',
    remain: ' Day(s) Left!',
    task: 'Task'
  },
  anniversary: {
    event: 'Event',
    shareWords: 'PGEbet 5th Anniversary! Cheers! Click the link to claim your ₹111+20 gift!#PGEbet ',
    sentence1: '1. Share this on Facebook: <span style="color: #FFFFFF;text-decoration: underline">PGEbet 5th<br> Anniversary! Cheers! Click the link to claim your ₹111+20 gift!#PGEbet<br><a style="color: inherit;" href="{link}">{link}</a></span>',
    sentence2: '2. Friends register via this link',
    sentence3: '3. Claim ₹11',
    word4Event2: ['<span style="color: #FFD600;">Obtain 30 likes for the post in Event 1.</span><br> (i.e., Facebook post with "PGE 5th Anniversary" and "#PGEbet" in the text)<br>', '<br>Message our Facebook fan page administrator to claim <span style="color: #FFD600;">₹111</span> upon approval.'],
    word4Event3: ['Follow our Facebook fan page <span style="color: #FFFFFF;">and</span> like the official 5th Anniversary Event posts.<br>', '<br><span style="color: #FFFFFF;">The administrator will randomly select lucky users daily to award mysterious</span> cash prizes.'],
    bottomWord: 'Thank you for reading this far<br>' +
      'Your focus and attention to detail are the<br>' +
      ' qualities of a successful player<br>' +
      'Please accept my heartfelt wishes<br>' +
      'May everything go smoothly',
    copyTextArr: ['Happy 5th Anniversary, PGEbet! 🥳🎉 Join the celebration and claim your special ₹111+20 gift! #PGEbet ',
      'Celebrate PGEbet\'s 5th Anniversary with us! 🎉🥂 Click now to claim your exclusive ₹111+20 gift! #PGEbet ',
      'Cheers to PGEbet\'s 5th Anniversary! 🌟🎊 Claim your exclusive ₹111+20 gift by clicking the link. #PGEbet ',
      'Happy 5th Anniversary, PGEbet family! 🎊🎁 Click the link to claim your ₹111+20 exclusive gift. #PGEbet ',
      'Celebrate with PGEbet! 🎉🌟 Don\'t miss your ₹111+20 gift – click the link for the 5th Anniversary celebration! #PGEbet '
    ]
  },
  welcome: {
    title: 'Welcome to PGEBet! ',
    message: 'Dear user,\n' +
      '\n' +
      'A warm welcome to PGEBet! \n' +
      'Claim your free cash, play games, and start earning!\n' +
      '\n' +
      'We\'ll send you all the important message here.\n' +
      '\n' +
      'Best regards,\n' +
      'PGEbet Team'
  },
  signal: {
    bookmark: 'Bookmark us',
    apk: 'APK',
    extra1: 'Extra ',
    extra2: 'Bonus!',
    link: 'Link',
    line: 'Line',
    follow: 'Follow Us'
  }
}



// WEBPACK FOOTER //
// ./src/assets/locale/en-US.js